/**
 * PocketFiler - Hindi (hi) Translation File
 * Complete translation - all keys from en.js
 */

const hi = {
  "nav.login": "लॉग इन",
  "nav.signup": "शुरू करें",
  "nav.logout": "लॉग आउट",
  "nav.dashboard": "डैशबोर्ड",
  "nav.virtualOffices": "वर्चुअल ऑफिस",
  "nav.clients": "ग्राहक",
  "nav.deals": "सौदे",
  "nav.documents": "दस्तावेज़",
  "nav.messages": "संदेश",
  "nav.settings": "सेटिंग्स",
  "nav.invoices": "चालान",
  "nav.templates": "टेम्पलेट",
  "nav.tasks": "कार्य",
  "nav.meetings": "बैठकें",
  "nav.analytics": "विश्लेषिकी",
  "landing.badge": "AI-संचालित डील प्लेटफॉर्म",
  "landing.hero.title": "किसी भी भाषा में महत्वपूर्ण सौदे करें",
  "landing.hero.titleHighlight": "AI के साथ",
  "landing.hero.subtitle": "PocketFiler व्यवसायों और व्यक्तियों को वैश्विक व्यापार से लेकर स्थानीय कार बिक्री और बीमा पॉलिसियों तक - दस्तावेज़-गहन, उच्च-विश्वास लेनदेन चलाने में मदद करता है - AI अनुवाद, दस्तावेज़ वर्कफ़्लो और हर सौदे के लिए डील रूम के साथ।",
  "landing.hero.cta.start": "मुफ्त शुरू करें",
  "landing.hero.cta.demo": "देखें कैसे काम करता है",
  "landing.useCases.title": "वैश्विक व्यापार, स्थानीय सेवाओं और बड़े व्यक्तिगत सौदों के लिए बनाया गया",
  "landing.useCases.subtitle": "चाहे आप विदेश से सामान आयात कर रहे हों या शहर में अपनी कार बेच रहे हों, PocketFiler आपको आत्मविश्वास से सौदा पूरा करने के उपकरण देता है।",
  "landing.useCases.globalTrade.title": "वैश्विक व्यापार और विनिर्माण",
  "landing.useCases.globalTrade.desc": "विदेशी आपूर्तिकर्ताओं को खोजें और उनके साथ काम करें, अनुपालन दस्तावेज़ इकट्ठा करें, और रीयल-टाइम अनुवाद के साथ डील रूम में बातचीत करें।",
  "landing.useCases.insurance.title": "बीमा, ऋण और पेशेवर सेवाएं",
  "landing.useCases.insurance.desc": "ग्राहकों को अपनी भाषा में आईडी, स्टेटमेंट और फॉर्म अपलोड करने के लिए आमंत्रित करें, फिर वर्चुअल ऑफिस में हर दस्तावेज़ और संदेश को ट्रैक करें।",
  "landing.useCases.realEstate.title": "रियल एस्टेट और संपत्ति लेनदेन",
  "landing.useCases.realEstate.desc": "खरीदारों और किरायेदारों को विभिन्न भाषाओं में आवेदन, खुलासे और अनुबंधों के माध्यम से मार्गदर्शन करें, सब कुछ प्रति लेनदेन एक डील रूम में।",
  "landing.useCases.vehicle.title": "निजी वाहन और संपत्ति बिक्री",
  "landing.useCases.vehicle.desc": "कारों, उपकरणों और अन्य उच्च-मूल्य वस्तुओं के बिक्री बिल और दस्तावेज़ीकरण को संभालने के लिए डील रूम और AI-जनित अनुबंधों का उपयोग करें।",
  "landing.audience.title": "व्यक्तियों और टीमों दोनों के लिए डिज़ाइन किया गया",
  "landing.audience.individuals.title": "व्यक्तियों के लिए",
  "landing.audience.individuals.bullet1": "स्पष्ट रिकॉर्ड के साथ कार खरीद, उपकरण या उच्च-मूल्य वस्तुओं जैसे महत्वपूर्ण एकबारगी सौदे पूरे करें।",
  "landing.audience.individuals.bullet2": "अपने फोन से दस्तावेज़ अपलोड करने और अनुबंधों की समीक्षा करने के लिए सरल सुरक्षित लिंक का उपयोग करें।",
  "landing.audience.individuals.bullet3": "सौदा पूरा होने के बाद भी प्रत्येक सौदे के सभी संदेश, फाइलें और अनुबंध ड्राफ्ट एक जगह रखें।",
  "landing.audience.teams.title": "व्यवसायों और टीमों के लिए",
  "landing.audience.teams.bullet1": "प्रत्येक सेवा लाइन (बीमा, रियल एस्टेट, ऋण, आयात) के लिए अनुकूलित चेकलिस्ट के साथ वर्चुअल ऑफिस सेट करें।",
  "landing.audience.teams.bullet2": "किसी भी भाषा में ग्राहकों को दस्तावेज़ अपलोड करने, अनुबंध पर हस्ताक्षर करने और डील रूम में संवाद करने के लिए आमंत्रित करें।",
  "landing.audience.teams.bullet3": "अपनी टीम को टाइमलाइन, AI सारांश और हर लेनदेन के पूर्ण इतिहास के साथ एक साझा कार्यस्थान दें।",
  "landing.howItWorks.title": "PocketFiler किसी भी सौदे के लिए कैसे काम करता है",
  "landing.howItWorks.subtitle": "चार शक्तिशाली सुविधाएं जो एक साथ काम करती हैं ताकि आप तेज़ी से और कम घर्षण के साथ सौदे पूरे कर सकें।",
  "landing.howItWorks.concierge.title": "AI कंसीयर्ज",
  "landing.howItWorks.concierge.desc": "आपका AI सहायक आपके व्यवसाय को सीखता है, सही वर्चुअल ऑफिस सेट करता है, और प्रत्येक प्रकार के सौदे के लिए दस्तावेज़ चेकलिस्ट कॉन्फ़िगर करता है।",
  "landing.howItWorks.translation.title": "ऑटो अनुवाद",
  "landing.howItWorks.translation.desc": "संदेश और मुख्य सामग्री पार्टियों के बीच तुरंत अनुवादित होते हैं, ताकि खरीदार, विक्रेता और ग्राहक अपनी भाषा में संवाद कर सकें।",
  "landing.howItWorks.documents.title": "स्मार्ट दस्तावेज़",
  "landing.howItWorks.documents.desc": "ग्राहक अपने फोन से दस्तावेज़ अपलोड करते हैं; AI मुख्य फील्ड निकालता है, गुणवत्ता जांचता है, और सौदे को धीमा करने से पहले समस्याओं को फ्लैग करता है।",
  "landing.howItWorks.dealRooms.title": "डील रूम और अनुबंध",
  "landing.howItWorks.dealRooms.desc": "प्रत्येक सौदे को टाइमलाइन, संदेश, दस्तावेज़ और AI-जनित अनुबंध ड्राफ्ट के साथ एक समर्पित रूम मिलता है जिसे आप समीक्षा और अंतिम रूप दे सकते हैं।",
  "landing.cta.title": "अपना अगला सौदा पूरा करने के लिए तैयार?",
  "landing.cta.subtitle": "उन व्यवसायों और व्यक्तियों से जुड़ें जो महत्वपूर्ण लेनदेन को आत्मविश्वास से संभालने के लिए PocketFiler का उपयोग कर रहे हैं।",
  "landing.cta.button": "मुफ्त खाता बनाएं",
  "landing.footer.tagline": "महत्वपूर्ण सौदे सरल बनाए।",
  "language.picker.title": "अपनी भाषा चुनें",
  "language.picker.subtitle": "हम सभी निर्देश, संदेश और अनुबंध इस भाषा में दिखाएंगे। अन्य लोग अपनी भाषा चुन सकते हैं; AI आपके लिए अनुवाद संभालेगा।",
  "language.picker.continue": "जारी रखें",
  "language.picker.playSample": "नमूना चलाएं",
  "language.picker.playing": "चल रहा है...",
  "language.picker.confirmation": "आपने {language} चुना है। हम आपको सब कुछ इस भाषा में दिखाएंगे। अन्य पार्टियां अपनी भाषा चुन सकती हैं; PocketFiler संदेश, दस्तावेज़ और अनुबंधों का अनुवाद करता है ताकि सभी समझ सकें।",
  "language.toast.saved": "भाषा सहेजी गई! इसे बदलने के लिए, अपने प्रोफ़ाइल में सेटिंग्स पर जाएं।",
  "language.confirm.title": "अपनी भाषा की पुष्टि करें",
  "language.confirm.subtitle": "यह भाषा सभी UI, संदेशों और अनुबंधों के लिए उपयोग की जाएगी।",
  "language.confirm.change": "भाषा बदलें",
  "language.confirm.continue": "के साथ जारी रखें",
  "language.confirm.chineseNote": "नोट: आपने सरलीकृत चीनी (简体中文) चुना है। यदि आप पारंपरिक चीनी पसंद करते हैं, तो कृपया अपना चयन बदलें।",
  "auth.login.title": "वापस स्वागत है",
  "auth.login.subtitle": "अपने PocketFiler खाते में लॉग इन करें",
  "auth.login.email": "ईमेल",
  "auth.login.password": "पासवर्ड",
  "auth.login.submit": "लॉग इन करें",
  "auth.login.noAccount": "खाता नहीं है?",
  "auth.login.signupLink": "साइन अप करें",
  "auth.login.error": "अमान्य ईमेल या पासवर्ड",
  "auth.signup.title": "अपना खाता बनाएं",
  "auth.signup.subtitle": "किसी भी भाषा में सौदे करना शुरू करें",
  "auth.signup.name": "पूरा नाम",
  "auth.signup.email": "ईमेल",
  "auth.signup.password": "पासवर्ड",
  "auth.signup.confirmPassword": "पासवर्ड की पुष्टि करें",
  "auth.signup.companyName": "कंपनी का नाम",
  "auth.signup.companyType": "उद्योग का प्रकार",
  "auth.signup.submit": "खाता बनाएं",
  "auth.signup.hasAccount": "पहले से खाता है?",
  "auth.signup.loginLink": "लॉग इन करें",
  "auth.signup.terms": "साइन अप करके, आप हमारी सेवा की शर्तों और गोपनीयता नीति से सहमत होते हैं।",
  "dashboard.title": "डैशबोर्ड",
  "dashboard.welcome": "वापस स्वागत है, {name}",
  "dashboard.aiSummary.title": "AI सारांश",
  "dashboard.aiSummary.generating": "सारांश बना रहा है...",
  "dashboard.stats.totalDeals": "कुल सौदे",
  "dashboard.stats.activeDeals": "सक्रिय सौदे",
  "dashboard.stats.totalClients": "कुल ग्राहक",
  "dashboard.stats.documentsProcessed": "संसाधित दस्तावेज़",
  "dashboard.recentDeals.title": "हाल के सौदे",
  "dashboard.recentDeals.viewAll": "सभी देखें",
  "dashboard.recentDeals.empty": "अभी तक कोई सौदा नहीं। शुरू करने के लिए अपना पहला सौदा बनाएं।",
  "dashboard.recentClients.title": "हाल के ग्राहक",
  "dashboard.recentClients.viewAll": "सभी देखें",
  "dashboard.recentClients.empty": "अभी तक कोई ग्राहक नहीं। शुरू करने के लिए अपने पहले ग्राहक को आमंत्रित करें।",
  "dashboard.quickActions.title": "त्वरित कार्रवाइयां",
  "dashboard.quickActions.createDeal": "सौदा बनाएं",
  "dashboard.quickActions.inviteClient": "ग्राहक आमंत्रित करें",
  "dashboard.quickActions.createOffice": "वर्चुअल ऑफिस बनाएं",
  "offices.title": "वर्चुअल ऑफिस",
  "offices.subtitle": "सेवा प्रकार के अनुसार अपने व्यवसाय को व्यवस्थित करें",
  "offices.create": "वर्चुअल ऑफिस बनाएं",
  "offices.empty.title": "अभी तक कोई वर्चुअल ऑफिस नहीं",
  "offices.empty.desc": "अपने सौदों और ग्राहकों को व्यवस्थित करने के लिए अपना पहला वर्चुअल ऑफिस बनाएं।",
  "offices.card.clients": "{count} ग्राहक",
  "offices.card.deals": "{count} सौदे",
  "offices.card.checklist": "चेकलिस्ट आइटम",
  "offices.checklist": "दस्तावेज़ चेकलिस्ट",
  "offices.noChecklist": "कोई दस्तावेज़ आवश्यक नहीं",
  "offices.dialog.title": "वर्चुअल ऑफिस बनाएं",
  "offices.dialog.desc": "एक विशिष्ट सेवा प्रकार के लिए नया कार्यस्थान सेट करें",
  "offices.dialog.name": "ऑफिस का नाम",
  "offices.dialog.namePlaceholder": "उदा: बीमा दावे, रियल एस्टेट बिक्री",
  "offices.dialog.type": "ऑफिस का प्रकार",
  "offices.dialog.description": "विवरण",
  "offices.dialog.descriptionPlaceholder": "यह ऑफिस क्या संभालता है वर्णन करें...",
  "offices.dialog.checklist": "दस्तावेज़ चेकलिस्ट",
  "offices.dialog.checklistHelp": "आवश्यक दस्तावेज़ों के लिए AI-जनित चेकलिस्ट",
  "offices.dialog.addItem": "आइटम जोड़ें",
  "offices.dialog.generateChecklist": "AI से बनाएं",
  "offices.dialog.creating": "बना रहा है...",
  "offices.dialog.create": "ऑफिस बनाएं",
  "offices.form.name": "ऑफिस का नाम",
  "offices.form.namePlaceholder": "उदा: बीमा सेवाएं, रियल एस्टेट आदि।",
  "offices.form.description": "विवरण",
  "offices.form.descPlaceholder": "यह ऑफिस किस प्रकार के सौदे संभालेगा?",
  "offices.form.checklistPlaceholder": "आवश्यक दस्तावेज़ जोड़ें...",
  "offices.ai.title": "AI-सहायता प्राप्त सेटअप",
  "offices.ai.desc": "हमारे AI कंसीयर्ज को आपके व्यवसाय की जरूरतों के बारे में पूछकर सही वर्चुअल ऑफिस सेट करने में मदद करने दें।",
  "offices.ai.manual": "मैन्युअल सेट करें",
  "offices.ai.start": "AI सेटअप शुरू करें",
  "offices.ai.startOnboarding": "मेरा वर्चुअल ऑफिस सेट करने में मदद करें",
  "offices.ai.suggestion": "AI सुझाव",
  "offices.ai.acceptSuggestion": "स्वीकार करें और ऑफिस बनाएं",
  "offices.ai.inputPlaceholder": "अपना जवाब टाइप करें...",
  "clients.title": "ग्राहक",
  "clients.subtitle": "अपने ग्राहकों और आमंत्रणों को प्रबंधित करें",
  "clients.invite": "ग्राहक आमंत्रित करें",
  "clients.empty.title": "अभी तक कोई ग्राहक नहीं",
  "clients.empty.desc": "शुरू करने के लिए अपने पहले ग्राहक को आमंत्रित करें।",
  "clients.table.name": "नाम",
  "clients.table.client": "ग्राहक",
  "clients.table.contact": "संपर्क",
  "clients.table.office": "ऑफिस",
  "clients.table.language": "भाषा",
  "clients.table.status": "स्थिति",
  "clients.table.actions": "कार्रवाइयां",
  "clients.status.invited": "आमंत्रित",
  "clients.status.active": "सक्रिय",
  "clients.status.completed": "पूर्ण",
  "clients.dialog.title": "नया ग्राहक आमंत्रित करें",
  "clients.dialog.name": "ग्राहक का नाम",
  "clients.dialog.email": "ईमेल पता",
  "clients.dialog.phone": "फोन नंबर",
  "clients.dialog.office": "वर्चुअल ऑफिस",
  "clients.dialog.language": "पसंदीदा भाषा",
  "clients.dialog.sending": "आमंत्रण भेज रहा है...",
  "clients.dialog.send": "आमंत्रण भेजें",
  "clients.toast.invited": "{name} को आमंत्रण भेजा गया",
  "clients.toast.deleted": "ग्राहक हटाया गया",
  "clients.toast.linkCopied": "आमंत्रण लिंक क्लिपबोर्ड पर कॉपी किया गया",
  "clients.invite.step1Title": "नया ग्राहक आमंत्रित करें",
  "clients.invite.step2Title": "आमंत्रण संदेश पूर्वावलोकन",
  "clients.invite.step3Title": "आमंत्रण भेजा गया!",
  "clients.invite.step1Desc": "ग्राहक संपर्क जानकारी दर्ज करें",
  "clients.invite.step2Desc": "आमंत्रण संदेश की समीक्षा और अनुकूलन करें",
  "clients.invite.step3Desc": "अपने ग्राहक के साथ आमंत्रण लिंक साझा करें",
  "clients.invite.nameLabel": "ग्राहक का नाम",
  "clients.invite.namePlaceholder": "उदा: राज कुमार",
  "clients.invite.contactMethod": "संपर्क विधि",
  "clients.invite.phone": "फोन नंबर",
  "clients.invite.customNote": "कस्टम नोट",
  "clients.invite.customNotePlaceholder": "इस ग्राहक के लिए विशेष निर्देश...",
  "clients.invite.previewMessage": "संदेश पूर्वावलोकन",
  "clients.invite.aiGenerated": "AI-जनित आमंत्रण संदेश",
  "clients.invite.messagePreview": "संदेश पूर्वावलोकन",
  "clients.invite.messageEditHint": "आप भेजने से पहले इस संदेश को संपादित कर सकते हैं",
  "clients.invite.documentsRequested": "अनुरोधित दस्तावेज़",
  "clients.invite.regenerate": "संदेश पुनर्जनित करें",
  "clients.invite.sendInvite": "आमंत्रण भेजें",
  "clients.invite.linkCreated": "आमंत्रण लिंक बनाया गया!",
  "clients.invite.linkCopiedToClipboard": "लिंक आपके क्लिपबोर्ड पर कॉपी किया गया है",
  "clients.invite.shareLink": "इस लिंक को ईमेल, SMS या व्यक्तिगत रूप से अपने ग्राहक के साथ साझा करें",
  "clients.invite.inviteAnother": "एक और आमंत्रित करें",
  "clients.invite.success": "ग्राहक आमंत्रित किया गया!",
  "clients.invite.linkCopied": "आमंत्रण लिंक कॉपी किया गया!",
  "clients.invite.yourAgent": "आपका एजेंट",
  "clients.invite.defaultOffice": "हमारा ऑफिस",
  "deals.title": "सौदे",
  "deals.subtitle": "अपने लेनदेन को ट्रैक और प्रबंधित करें",
  "deals.create": "सौदा बनाएं",
  "deals.empty.title": "अभी तक कोई सौदा नहीं",
  "deals.empty.desc": "शुरू करने के लिए अपना पहला सौदा बनाएं।",
  "deals.search": "सौदे खोजें...",
  "deals.filter.all": "सभी सौदे",
  "deals.filter.active": "सक्रिय",
  "deals.filter.pending": "लंबित",
  "deals.filter.closed": "बंद",
  "deals.column.draft": "ड्राफ्ट",
  "deals.column.active": "सक्रिय",
  "deals.column.pending": "लंबित",
  "deals.column.closed": "बंद",
  "deals.card.documents": "{count} दस्तावेज़",
  "deals.card.messages": "{count} संदेश",
  "deals.dialog.title": "नया सौदा बनाएं",
  "deals.dialog.dealTitle": "सौदे का शीर्षक",
  "deals.dialog.dealTitlePlaceholder": "उदा: वाहन खरीद - Honda Civic 2023",
  "deals.dialog.client": "ग्राहक",
  "deals.dialog.office": "वर्चुअल ऑफिस",
  "deals.dialog.type": "सौदे का प्रकार",
  "deals.dialog.notes": "नोट्स",
  "deals.dialog.notesPlaceholder": "इस सौदे के बारे में नोट्स जोड़ें...",
  "deals.dialog.creating": "बना रहा है...",
  "deals.dialog.create": "सौदा बनाएं",
  "dealRoom.back": "सौदों पर वापस जाएं",
  "dealRoom.readOnly.title": "केवल पढ़ने के लिए",
  "dealRoom.readOnly.closedMessage": "यह सौदा बंद हो गया है। डील रूम अब संदर्भ और ऑडिट उद्देश्यों के लिए केवल पढ़ने योग्य है।",
  "dealRoom.readOnly.cancelledMessage": "यह सौदा रद्द कर दिया गया है। डील रूम अब संदर्भ और ऑडिट उद्देश्यों के लिए केवल पढ़ने योग्य है।",
  "dealRoom.tabs.messages": "संदेश",
  "dealRoom.tabs.documents": "दस्तावेज़",
  "dealRoom.tabs.contract": "अनुबंध",
  "dealRoom.timeline.title": "गतिविधि टाइमलाइन",
  "dealRoom.timeline.empty": "अभी तक कोई गतिविधि नहीं",
  "dealRoom.details.title": "सौदे का विवरण",
  "dealRoom.details.notes": "नोट्स",
  "dealRoom.details.type": "प्रकार",
  "dealRoom.details.documents": "दस्तावेज़",
  "dealRoom.details.messages": "संदेश",
  "dealRoom.aiSummary.title": "AI सारांश",
  "dealRoom.aiSummary.generating": "सारांश बना रहा है...",
  "dealRoom.messages.empty": "अभी तक कोई संदेश नहीं। बातचीत शुरू करें।",
  "dealRoom.messages.placeholder": "संदेश टाइप करें...",
  "dealRoom.messages.send": "भेजें",
  "dealRoom.messages.sending": "भेज रहा है...",
  "dealRoom.messages.showOriginal": "मूल दिखाएं",
  "dealRoom.messages.showTranslation": "अनुवाद दिखाएं",
  "dealRoom.messages.translatedFrom": "{language} से अनुवादित",
  "dealRoom.messages.suggestReply": "जवाब सुझाएं",
  "dealRoom.documents.empty": "अभी तक कोई दस्तावेज़ अपलोड नहीं किया गया।",
  "dealRoom.documents.upload": "दस्तावेज़ अपलोड करें",
  "dealRoom.documents.uploading": "अपलोड हो रहा है...",
  "dealRoom.documents.analyze": "विश्लेषण",
  "dealRoom.documents.analyzing": "विश्लेषण कर रहा है...",
  "dealRoom.documents.download": "डाउनलोड",
  "dealRoom.documents.delete": "हटाएं",
  "dealRoom.documents.pending": "विश्लेषण लंबित",
  "dealRoom.documents.analyzed": "विश्लेषित",
  "dealRoom.documents.aiAnalysis": "AI दस्तावेज़ विश्लेषण",
  "dealRoom.documents.type": "दस्तावेज़ प्रकार",
  "dealRoom.documents.confidence": "विश्वास",
  "dealRoom.documents.summary": "सारांश",
  "dealRoom.documents.issues": "समस्याएं",
  "dealRoom.contract.empty.title": "अभी तक कोई अनुबंध नहीं बनाया गया",
  "dealRoom.contract.empty.desc": "इस सौदे के लिए AI अनुबंध ड्राफ्ट बनाएं।",
  "dealRoom.contract.generate": "अनुबंध ड्राफ्ट बनाएं",
  "dealRoom.contract.regenerate": "अनुबंध पुनर्जनित करें",
  "dealRoom.contract.generating": "बना रहा है...",
  "dealRoom.contract.aiLabel": "AI-जनित अनुबंध ड्राफ्ट",
  "dealRoom.contract.language": "भाषा",
  "dealRoom.contract.copy": "कॉपी करें",
  "dealRoom.contract.copied": "क्लिपबोर्ड पर कॉपी किया गया",
  "dealRoom.contract.type": "अनुबंध प्रकार",
  "dealRoom.contract.generated": "बनाया गया",
  "dealRoom.contract.languages": "भाषाएं",
  "dealRoom.contract.status": "स्थिति",
  "dealRoom.contract.notice": "AI दस्तावेज़ विश्लेषण: एक या अधिक खंडों का चयनित भाषाओं के बीच सीधा समकक्ष नहीं है। हमने वर्णनात्मक भाषा का उपयोग किया है। कृपया इन अनुभागों की सावधानीपूर्वक समीक्षा करें और यदि आवश्यक हो तो दूसरे पक्ष से पुष्टि करें।",
  "dealRoom.contract.dialog.title": "अनुबंध ड्राफ्ट बनाएं",
  "dealRoom.contract.dialog.desc": "AI सौदे के विवरण के आधार पर द्विभाषी अनुबंध बनाएगा।",
  "dealRoom.contract.dialog.disclaimer": "यह समीक्षा उद्देश्यों के लिए AI-जनित ड्राफ्ट है। हस्ताक्षर करने से पहले कानूनी पेशेवर से समीक्षा करवाएं।",
  "dealRoom.contract.dialog.type": "अनुबंध प्रकार",
  "dealRoom.contract.dialog.languages": "भाषाएं",
  "dealRoom.contract.dialog.languagesHelp": "अपने द्विभाषी अनुबंध के लिए दो भाषाएं चुनें। सभी Tier 1 भाषाएं पूरी तरह से समर्थित हैं।",
  "dealRoom.contract.dialog.primary": "प्राथमिक",
  "dealRoom.contract.dialog.secondary": "द्वितीयक",
  "dealRoom.contract.dialog.terms": "विशेष शर्तें",
  "dealRoom.contract.dialog.termsPlaceholder": "कोई विशेष शर्तें या नियम जोड़ें...",
  "dealRoom.contract.dialog.generate": "अनुबंध बनाएं",
  "dealRoom.contract.dialog.generating": "बना रहा है...",
  "dealRoom.status.change": "स्थिति बदलें",
  "dealRoom.status.dialog.title": "सौदे की स्थिति बदलें",
  "dealRoom.status.dialog.from": "से",
  "dealRoom.status.dialog.to": "को",
  "dealRoom.status.dialog.reason": "कारण (वैकल्पिक)",
  "dealRoom.status.dialog.reasonPlaceholder": "आप स्थिति क्यों बदल रहे हैं?",
  "dealRoom.status.dialog.confirm": "परिवर्तन की पुष्टि करें",
  "dealRoom.status.dialog.changing": "बदल रहा है...",
  "dealRoom.status.toast.changed": "स्थिति {status} में बदल गई",
  "dealRoom.upgrade.title": "Business में अपग्रेड करें",
  "dealRoom.upgrade.desc": "अनुबंध बनाने के लिए Business प्लान की आवश्यकता है।",
  "dealRoom.upgrade.features": "Business के साथ, आपको मिलता है:",
  "dealRoom.upgrade.feature1": "AI-जनित अनुबंध ड्राफ्ट",
  "dealRoom.upgrade.feature2": "उन्नत दस्तावेज़ विश्लेषण",
  "dealRoom.upgrade.feature3": "प्राथमिकता समर्थन",
  "dealRoom.upgrade.button": "अभी अपग्रेड करें",
  "settings.title": "सेटिंग्स",
  "settings.subtitle": "अपना खाता और संगठन प्रबंधित करें",
  "settings.tabs.profile": "प्रोफ़ाइल",
  "settings.tabs.organization": "संगठन",
  "settings.profile.title": "प्रोफ़ाइल सेटिंग्स",
  "settings.profile.subtitle": "अपनी व्यक्तिगत जानकारी प्रबंधित करें",
  "settings.profile.name": "पूरा नाम",
  "settings.profile.email": "ईमेल",
  "settings.profile.emailNote": "ईमेल बदला नहीं जा सकता",
  "settings.profile.language": "पसंदीदा भाषा",
  "settings.profile.languageHelp": "सभी UI, संदेश और अनुबंध इस भाषा में प्रदर्शित होंगे।",
  "settings.profile.save": "परिवर्तन सहेजें",
  "settings.profile.saving": "सहेज रहा है...",
  "settings.profile.saved": "प्रोफ़ाइल अपडेट किया गया",
  "settings.org.title": "संगठन सेटिंग्स",
  "settings.org.subtitle": "अपनी व्यावसायिक जानकारी प्रबंधित करें",
  "settings.org.name": "संगठन का नाम",
  "settings.org.type": "उद्योग का प्रकार",
  "settings.org.billingEmail": "बिलिंग ईमेल",
  "settings.org.plan": "प्लान",
  "settings.org.verification": "सत्यापन स्थिति",
  "settings.org.save": "परिवर्तन सहेजें",
  "settings.org.saving": "सहेज रहा है...",
  "settings.org.saved": "संगठन अपडेट किया गया",
  "settings.org.noOrg": "कोई संगठन नहीं मिला",
  "invite.language.title": "अपनी भाषा चुनें",
  "invite.language.subtitle": "हम सभी निर्देश आपकी भाषा में दिखाएंगे।",
  "invite.welcome.title": "में आपका स्वागत है",
  "invite.welcome.subtitle": "हम आपके दस्तावेज़ प्राप्त करने के लिए तैयार हैं।",
  "invite.welcome.time": "5-10 मिनट",
  "invite.welcome.timeLabel": "अनुमानित समय",
  "invite.welcome.secure": "सुरक्षित और मुफ्त",
  "invite.welcome.secureDesc": "आपके दस्तावेज़ एन्क्रिप्टेड हैं। यह सेवा आपके लिए मुफ्त है।",
  "invite.welcome.start": "अपलोड शुरू करें",
  "invite.documents.needed": "आवश्यक दस्तावेज़",
  "invite.upload.title": "दस्तावेज़ अपलोड करें",
  "invite.upload.dragDrop": "यहां फ़ाइल खींचें और छोड़ें, या चुनने के लिए क्लिक करें",
  "invite.upload.or": "या",
  "invite.upload.takePhoto": "छवियाँ",
  "invite.upload.browse": "फ़ाइलें",
  "invite.upload.uploading": "अपलोड हो रहा है...",
  "invite.upload.analyzing": "दस्तावेज़ जांच रहा है...",
  "invite.upload.success": "सफलतापूर्वक अपलोड किया गया",
  "invite.upload.next": "अगला दस्तावेज़",
  "invite.upload.finish": "सभी की समीक्षा करें",
  "invite.upload.skip": "अभी छोड़ें",
  "invite.upload.progress": "प्रगति",
  "invite.complete.title": "पूर्ण!",
  "invite.complete.subtitle": "आपके दस्तावेज़ सफलतापूर्वक जमा किए गए हैं।",
  "invite.complete.message": "हमें आपके सभी दस्तावेज़ प्राप्त हो गए हैं। जल्द ही आपसे संपर्क किया जाएगा।",
  "invite.complete.summary": "जमा किए गए दस्तावेज़",
  "invite.complete.securityNote": "आपके दस्तावेज़ सुरक्षित रूप से संग्रहीत हैं और केवल अधिकृत कर्मियों द्वारा ही एक्सेस किए जाएंगे।",
  "invite.chat.title": "अपने एजेंट से चैट करें",
  "invite.chat.placeholder": "संदेश टाइप करें...",
  "invite.chat.empty": "अभी तक कोई संदेश नहीं। बातचीत शुरू करें।",
  "invite.chat.sent": "आपका संदेश भेज दिया गया है।",
  "invite.chat.willRespond": "हम जल्द से जल्द जवाब देंगे।",
  "invite.chat.sending": "भेज रहा है...",
  "invite.error.title": "अमान्य या समाप्त लिंक",
  "invite.error.message": "यह आमंत्रण लिंक अब मान्य नहीं है। कृपया नए लिंक के लिए प्रेषक से संपर्क करें।",
  "common.loading": "लोड हो रहा है...",
  "common.save": "सहेजें",
  "common.cancel": "रद्द करें",
  "common.delete": "हटाएं",
  "common.edit": "संपादित करें",
  "common.create": "बनाएं",
  "common.close": "बंद करें",
  "common.dismiss": "बंद करें",
  "common.confirm": "पुष्टि करें",
  "common.back": "वापस",
  "common.next": "अगला",
  "common.previous": "पिछला",
  "common.of": "का",
  "common.search": "खोजें",
  "common.filter": "फ़िल्टर",
  "common.sort": "क्रमबद्ध करें",
  "common.viewAll": "सभी देखें",
  "common.refresh": "रीफ्रेश",
  "common.retry": "पुनः प्रयास",
  "common.yes": "हां",
  "common.no": "नहीं",
  "common.or": "या",
  "common.and": "और",
  "common.optional": "वैकल्पिक",
  "common.required": "आवश्यक",
  "status.draft": "ड्राफ्ट",
  "status.active": "सक्रिय",
  "status.pending": "लंबित",
  "status.pending_documents": "दस्तावेज़ लंबित",
  "status.pending_signature": "हस्ताक्षर लंबित",
  "status.on_hold": "होल्ड पर",
  "status.closed": "बंद",
  "status.cancelled": "रद्द",
  "error.generic": "कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
  "error.network": "नेटवर्क त्रुटि। कृपया अपना कनेक्शन जांचें।",
  "error.unauthorized": "आप इस क्रिया को करने के लिए अधिकृत नहीं हैं।",
  "error.notFound": "अनुरोधित संसाधन नहीं मिला।",
  "error.validation": "कृपया अपना इनपुट जांचें और पुनः प्रयास करें।",
  "error.serverError": "सर्वर त्रुटि। कृपया बाद में पुनः प्रयास करें।",
  "success.saved": "परिवर्तन सफलतापूर्वक सहेजे गए।",
  "success.created": "सफलतापूर्वक बनाया गया।",
  "success.deleted": "सफलतापूर्वक हटाया गया।",
  "success.sent": "सफलतापूर्वक भेजा गया।",
  "success.uploaded": "सफलतापूर्वक अपलोड किया गया।",
  "time.justNow": "अभी",
  "time.minutesAgo": "{count} मिनट पहले",
  "time.hoursAgo": "{count} घंटे पहले",
  "time.daysAgo": "{count} दिन पहले",
  "time.today": "आज",
  "time.yesterday": "कल",
  "dealRoom.notFound": "सौदा नहीं मिला",
  "dealRoom.loading": "सौदा लोड हो रहा है...",
  "dealRoom.conversation.title": "सौदे की बातचीत",
  "dealRoom.conversation.you": "आप",
  "dealRoom.conversation.client": "ग्राहक",
  "dealRoom.messages.hideOriginal": "मूल छुपाएं",
  "dealRoom.messages.original": "मूल ({language})",
  "dealRoom.messages.disabled": "इस सौदे की स्थिति के लिए संदेश अक्षम हैं",
  "dealRoom.messages.aiSuggest": "AI सुझाया गया जवाब",
  "dealRoom.documents.title": "दस्तावेज़",
  "dealRoom.documents.uploadDisabled": "अपलोड अक्षम",
  "dealRoom.documents.pendingAnalysis": "विश्लेषण लंबित",
  "dealRoom.documents.uploadFirst": "पहला दस्तावेज़ अपलोड करें",
  "dealRoom.documents.uploadHelp": "AI विश्लेषण के लिए इस सौदे में दस्तावेज़ अपलोड करें",
  "dealRoom.documents.uploadDisabledHelp": "इस सौदे की स्थिति के लिए दस्तावेज़ अपलोड अक्षम हैं",
  "dealRoom.documents.analyzeWithAI": "AI से विश्लेषण करें",
  "dealRoom.documents.notAnalyzed": "अभी तक विश्लेषित नहीं",
  "dealRoom.documents.notAnalyzedHelp": "दस्तावेज़ प्रकार, फ़ील्ड निकालने और इनसाइट्स प्राप्त करने के लिए AI विश्लेषण चलाएं",
  "dealRoom.documents.analyzeDocument": "दस्तावेज़ विश्लेषण करें",
  "dealRoom.documents.extractedFields": "निकाले गए फ़ील्ड",
  "dealRoom.documents.issuesDetected": "पता चली समस्याएं",
  "dealRoom.documents.preview": "पूर्वावलोकन",
  "dealRoom.documents.uploaded": "अपलोड किया गया",
  "dealRoom.documents.deleteConfirm": "क्या आप वाकई इस दस्तावेज़ को हटाना चाहते हैं?",
  "dealRoom.onHold.message": "यह सौदा होल्ड पर है। दस्तावेज़ अपलोड अक्षम हैं। आप अभी भी समन्वय के लिए संदेश भेज सकते हैं।",
  "dealRoom.pendingSignature.message": "अनुबंध हस्ताक्षर के लिए तैयार है। अनुबंध पर हस्ताक्षर होने या वापस लेने तक दस्तावेज़ अपलोड अक्षम हैं।",
  "dealRoom.status.current": "वर्तमान",
  "dealRoom.status.finalWarning": "यह अंतिम स्थिति है। इस क्रिया के बाद सौदा फिर से नहीं खोला जा सकता।",
  "dealRoom.contract.purchaseAgreement": "खरीद अनुबंध",
  "dealRoom.contract.purchaseAgreementDesc": "मानक खरीद अनुबंध",
  "dealRoom.contract.noContract": "अभी तक कोई अनुबंध नहीं",
  "dealRoom.contract.noContractDesc": "अपने सौदे के विवरण और दस्तावेज़ों के आधार पर AI-संचालित अनुबंध ड्राफ्ट बनाएं।",
  "dealRoom.contract.notAvailable": "{status} सौदों के लिए अनुबंध निर्माण उपलब्ध नहीं है।",
  "dealRoom.contract.locked": "हस्ताक्षर की प्रतीक्षा में अनुबंध निर्माण लॉक है।",
  "dealRoom.contract.requiresPlan": "Business Starter प्लान आवश्यक है",
  "dealRoom.toast.dealUpdated": "सौदा अपडेट किया गया",
  "dealRoom.toast.statusChanged": "सौदे की स्थिति {status} में बदल गई",
  "dealRoom.toast.statusFailed": "स्थिति बदलने में विफल",
  "dealRoom.toast.contractGenerated": "अनुबंध ड्राफ्ट सफलतापूर्वक बनाया गया",
  "dealRoom.toast.contractCopied": "{language} अनुबंध क्लिपबोर्ड पर कॉपी किया गया",
  "dealRoom.toast.messageFailed": "संदेश भेजने में विफल",
  "dealRoom.toast.suggestionFailed": "सुझाव बनाने में विफल",
  "dealRoom.toast.documentUploaded": "दस्तावेज़ अपलोड किया गया",
  "dealRoom.toast.uploadFailed": "अपलोड विफल",
  "dealRoom.toast.analysisComplete": "AI दस्तावेज़ विश्लेषण पूर्ण",
  "dealRoom.toast.analysisFailed": "AI विश्लेषण विफल",
  "dealRoom.toast.documentDeleted": "दस्तावेज़ हटाया गया",
  "dealRoom.toast.deleteFailed": "हटाने में विफल",
  "dealRoom.details.created": "बनाया गया",
  "dealRoom.details.addNotes": "सौदे के नोट्स जोड़ें...",
  "onboarding.brand": "PocketFiler",
  "onboarding.skip": "अभी छोड़ें",
  "onboarding.badge": "AI-संचालित सेटअप",
  "onboarding.welcome": "स्वागत है, {name}!",
  "onboarding.welcomeGeneric": "स्वागत है!",
  "onboarding.subtitle": "आइए आपका PocketFiler कार्यस्थान सेट करें। हमारे AI कंसीयर्ज को अपने व्यवसाय के बारे में बताएं, और हम आपके लिए सब कुछ कॉन्फ़िगर करेंगे।",
  "onboarding.step1": "अपने व्यवसाय और जरूरतों का वर्णन करें",
  "onboarding.step2": "AI आपका सेटअप सुझाता है",
  "onboarding.step3": "सौदे प्रबंधित करना शुरू करें",
  "onboarding.concierge.title": "AI कंसीयर्ज",
  "onboarding.toast.officeCreated": "वर्चुअल ऑफिस बनाया गया!",
  "auth.signup.accountType": "खाता प्रकार",
  "auth.signup.passwordTooShort": "पासवर्ड कम से कम 8 अक्षर का होना चाहिए",
  "auth.signup.passwordsDoNotMatch": "पासवर्ड मेल नहीं खाते",
  "auth.signup.success": "खाता सफलतापूर्वक बनाया गया!",
  "captions.connecting": "कनेक्ट हो रहा है...",
  "captions.disable": "कैप्शन अक्षम करें",
  "captions.enable": "कैप्शन सक्षम करें",
  "captions.error.connect": "कैप्शन सेवा से कनेक्ट करने में विफल",
  "captions.error.toggle": "कैप्शन टॉगल करने में विफल",
  "captions.language": "कैप्शन भाषा",
  "captions.live": "लाइव",
  "captions.off": "कैप्शन बंद",
  "captions.on": "कैप्शन चालू",
  "captions.original": "मूल",
  "captions.translated": "अनुवादित",
  "captions.translating": "अनुवाद हो रहा है...",
  "clients.joined.empty.desc": "आपने अभी तक कोई संगठन ज्वाइन नहीं किया है। उनसे कहें कि वे आपको अपने PocketFiler कार्यक्षेत्र में आमंत्रित करें।",
  "clients.joined.empty.title": "कोई संगठन नहीं जुड़ा",
  "clients.nav.joinedOrgs": "जुड़े संगठन",
  "clients.nav.myClients": "मेरे ग्राहक",
  "clients.table.joinedDate": "जुड़ने की तारीख",
  "clients.table.organization": "संगठन",
  "common.backToHome": "होम पर वापस जाएं",
  "common.deleteConfirmDesc": "यह क्रिया पूर्ववत नहीं की जा सकती। यह आइटम को स्थायी रूप से हटा देगी और हमारे सर्वर से डेटा हटा देगी।",
  "common.deleteConfirmTitle": "क्या आप बिल्कुल निश्चित हैं?",
  "common.noResults": "कोई परिणाम नहीं मिला",
  "connect.createAccount": "निःशुल्क खाता बनाएं",
  "connect.dealCreated": "डील सफलतापूर्वक बनाई गई",
  "connect.error.invalid": "अमान्य कनेक्ट लिंक",
  "connect.error.invalidDesc": "यह कनेक्ट लिंक अमान्य है या समाप्त हो गया है।",
  "connect.error.server": "कुछ गलत हुआ",
  "connect.error.serverDesc": "कृपया बाद में दोबारा प्रयास करें।",
  "connect.infoUnauth": "यह व्यक्ति बहु-भाषी डील्स और दस्तावेज़ों को सुरक्षित रूप से प्रबंधित करने के लिए PocketFiler का उपयोग करता है।",
  "connect.joinOffice": "वर्चुअल ऑफिस में शामिल हों",
  "connect.loggedInAs": "लॉग इन हैं",
  "connect.login": "लॉग इन",
  "connect.startDeal": "डील शुरू करें",
  "connect.titleAuth": "आप कनेक्ट हो रहे हैं",
  "connect.titleUnauth": "कनेक्ट करें",
  "connect.typeOrg": "संगठन",
  "connect.typePerson": "व्यक्ति",
  "contacts.actions.call": "कॉल करें",
  "contacts.actions.email": "ईमेल",
  "contacts.actions.message": "ऐप में मैसेज भेजें",
  "contacts.actions.noEmail": "कोई ईमेल पता नहीं",
  "contacts.actions.noPhone": "कोई फोन नंबर नहीं",
  "contacts.actions.sms": "मैसेज भेजें",
  "contacts.actions.title": "संपर्क {name}",
  "contacts.actions.whatsapp": "WhatsApp",
  "contacts.dialog.name": "संपर्क नाम",
  "contacts.dialog.title": "नया संपर्क जोड़ें",
  "contacts.empty.desc": "शुरुआत करने के लिए अपना पहला संपर्क जोड़ें।",
  "contacts.empty.title": "अभी तक कोई संपर्क नहीं",
  "contacts.invite": "संपर्क जोड़ें",
  "contacts.invite.customNotePlaceholder": "इस संपर्क के बारे में कोई विशेष नोट...",
  "contacts.invite.nameLabel": "संपर्क नाम",
  "contacts.invite.shareLink": "इस लिंक को अपने संपर्क के साथ ईमेल, SMS या व्यक्तिगत रूप से साझा करें",
  "contacts.invite.step1Desc": "संपर्क जानकारी दर्ज करें",
  "contacts.invite.step1Title": "नया संपर्क जोड़ें",
  "contacts.subtitle": "अपने संपर्कों और आमंत्रणों को प्रबंधित करें",
  "contacts.table.contact": "संपर्क",
  "contacts.title": "संपर्क",
  "contacts.toast.deleted": "संपर्क हटा दिया गया",
  "contacts.toast.invited": "संपर्क जोड़ा गया: {name}",
  "contacts.toast.linkCopied": "लिंक क्लिपबोर्ड पर कॉपी किया गया",
  "dashboard.quickActions.inviteContact": "संपर्क जोड़ें",
  "dashboard.recentContacts.empty": "अभी तक कोई संपर्क नहीं। शुरुआत करने के लिए अपना पहला संपर्क आमंत्रित करें।",
  "dashboard.recentContacts.title": "हाल के संपर्क",
  "dashboard.recentContacts.viewAll": "सभी देखें",
  "dashboard.stats.totalContacts": "कुल संपर्क",
  "dealRoom.contract.analysisWarning": "कुछ दस्तावेज़ों का अभी तक विश्लेषण नहीं हुआ है। AI विश्लेषण अनुबंध की सटीकता में सुधार करता है।",
  "dealRoom.conversation.colleague": "सहकर्मी",
  "dealRoom.details.clients": "ग्राहक",
  "dealRoom.documents.previewNotAvailable": "पूर्वावलोकन उपलब्ध नहीं। डाउनलोड हो रहा है...",
  "dealRoom.incomingCall.accept": "स्वीकार करें",
  "dealRoom.incomingCall.decline": "अस्वीकार करें",
  "dealRoom.incomingCall.inProgress": "कॉल चल रही है",
  "dealRoom.incomingCall.started": "{name} ने कॉल शुरू की",
  "dealRoom.messages.connecting": "चैट से कनेक्ट हो रहे हैं...",
  "dealRoom.messages.connectionError": "बातचीत से कनेक्ट नहीं हो सका।",
  "dealRoom.pendingSignature.loading": "हस्ताक्षर स्थिति लोड हो रही है...",
  "dealRoom.pendingSignature.signedWaitingOthers": "सफलतापूर्वक हस्ताक्षरित। अन्य प्रतिभागियों का इंतज़ार है।",
  "dealRoom.readOnly.completedMessage": "यह डील सफलतापूर्वक पूरी हो गई है। डील रूम अब संदर्भ और ऑडिट के लिए केवल-पढ़ने के लिए है।",
  "dealRoom.signature.signed": "हस्ताक्षरित",
  "dealRoom.signature.signedByYou": "आपके द्वारा हस्ताक्षरित",
  "dealRoom.signature.success": "अनुबंध सफलतापूर्वक हस्ताक्षरित!",
  "dealRoom.signaturesList.clients": "ग्राहक",
  "dealRoom.signaturesList.dealOwner": "डील मालिक",
  "dealRoom.signaturesList.pending": "लंबित",
  "dealRoom.signaturesList.signedOn": "हस्ताक्षर तारीख",
  "dealRoom.signaturesList.title": "हस्ताक्षर",
  "dealRoom.signaturesList.viewSignatures": "हस्ताक्षर देखें",
  "dealRoom.signedByAll.addPayment": "भुगतान जोड़ें",
  "dealRoom.signedByAll.message": "सभी प्रतिभागियों द्वारा हस्ताक्षरित। भुगतान की ओर आगे बढ़ें।",
  "dealRoom.timeline.createdBy": "{name} द्वारा",
  "deals.tabs.all": "सभी डील्स",
  "deals.tabs.my": "मेरी डील्स",
  "deals.validation.clientRequired": "कृपया कम से कम एक ग्राहक चुनें",
  "deals.validation.notesLength": "नोट्स 200 अक्षर या कम होने चाहिए",
  "deals.validation.titleLength": "शीर्षक 100 अक्षर या कम होना चाहिए",
  "deals.validation.titleRequired": "डील का शीर्षक आवश्यक है",
  "documents.readAloud.analyzeFirst": "इसे ज़ोर से पढ़ने के लिए पहले इस दस्तावेज़ का विश्लेषण करें।",
  "documents.readAloud.error": "ज़ोर से पढ़ना विफल",
  "documents.readAloud.title": "ज़ोर से पढ़ें",
  "landing.cta.secondary": "नमूना डील रूम देखें",
  "landing.hero.trust": "निःशुल्क योजना। क्रेडिट कार्ड की आवश्यकता नहीं। 11 भाषाओं में उपलब्ध।",
  "landing.socialProof": "40 देशों के 500+ व्यवसायों द्वारा विश्वसनीय",
  "landing.useCases.personal.desc": "वाहन, उपकरण या संपत्ति जैसे महत्वपूर्ण एकल सौदों को स्पष्ट रिकॉर्ड, AI अनुबंध और दस्तावेज़ साझाकरण के लिए सुरक्षित लिंक के साथ पूरा करें।",
  "landing.useCases.personal.title": "उच्च-मूल्य व्यक्तिगत लेनदेन",
  "landing.useCases.professional.desc": "AI सहायता के साथ ग्राहकों को दस्तावेज़ अपलोड करने के लिए आमंत्रित करें, सुरक्षित वर्चुअल ऑफिस में हर इंटरैक्शन को ट्रैक करें, और द्विभाषी डिजिटल अनुबंध तैयार करें—सब एक ही कार्यक्षेत्र से।",
  "landing.useCases.professional.subtitle": "बीमा, रियल एस्टेट, ऋण",
  "landing.useCases.professional.title": "पेशेवर सेवाएं",
  "livekit.call": "कॉल",
  "livekit.connecting": "कनेक्ट हो रहा है...",
  "livekit.error.connect": "कॉल से कनेक्ट करने में विफल। कृपया दोबारा प्रयास करें।",
  "livekit.error.connection": "कनेक्शन एरर। कृपया अपना नेटवर्क जांचें और दोबारा प्रयास करें।",
  "livekit.error.permission": "आपको इस कॉल में शामिल होने की अनुमति नहीं है।",
  "livekit.hint": "ऐप्स बदलने के बजाय इस डील के अंदर बात करें।",
  "livekit.inCall": "कॉल में",
  "livekit.joinCall": "कॉल में शामिल हों",
  "livekit.leaveCall": "कॉल छोड़ें",
  "livekit.participant": "प्रतिभागी",
  "livekit.participants": "प्रतिभागी",
  "messages.readAloud.error": "ज़ोर से पढ़ना विफल",
  "messages.readAloud.title": "ज़ोर से पढ़ें",
  "nav.companyProfile": "कंपनी प्रोफ़ाइल",
  "nav.contacts": "संपर्क",
  "nav.directory": "निर्देशिका",
  "nav.products": "उत्पाद",
  "offices.card.contacts": "{count} संपर्क",
  "pwa.banner.install": "इंस्टॉल करें",
  "pwa.banner.subtitle": "तेज़ एक्सेस, ऑफलाइन काम करता है",
  "pwa.banner.title": "PocketFiler ऐप डाउनलोड करें",
  "pwa.firefox.hint": "Firefox में, इस ऐप को अपने डेस्कटॉप पर जोड़ने के लिए एड्रेस बार में इंस्टॉल आइकन (⊕) देखें।",
  "pwa.installApp": "ऐप इंस्टॉल करें",
  "pwa.installed": "ऐप सफलतापूर्वक इंस्टॉल किया गया!",
  "pwa.ios.description": "सर्वोत्तम अनुभव के लिए PocketFiler को अपनी होम स्क्रीन पर जोड़ें:",
  "pwa.ios.gotIt": "समझ गया",
  "pwa.ios.inToolbar": "अपने ब्राउज़र टूलबार में",
  "pwa.ios.inTopRight": "ऊपरी दाएं कोने में",
  "pwa.ios.shareButton": "शेयर बटन",
  "pwa.ios.step1": "टैप करें",
  "pwa.ios.step2": "नीचे स्क्रॉल करें और टैप करें",
  "pwa.ios.step3": "टैप करें",
  "pwa.ios.title": "PocketFiler इंस्टॉल करें",
  "pwa.iosHint": "PocketFiler इंस्टॉल करने के लिए शेयर आइकन टैप करें और \\\"होम स्क्रीन पर जोड़ें\\\" चुनें।",
  "pwa.opera.chromeHint": "इस पेज को खोलें, फिर एड्रेस बार में इंस्टॉल आइकन पर क्लिक करें",
  "pwa.opera.desktopNotSupported": "Opera डेस्कटॉप PWA इंस्टॉलेशन का समर्थन नहीं करता। PocketFiler को ऐप के रूप में इंस्टॉल करने के लिए, कृपया इसे Google Chrome या Microsoft Edge में खोलें।",
  "pwa.opera.edgeHint": "इस पेज को खोलें, फिर एड्रेस बार में इंस्टॉल आइकन (⊕) पर क्लिक करें",
  "pwa.opera.mobileAddPage": "पेज जोड़ें",
  "pwa.opera.mobileDescription": "Opera के नीचे + आइकन टैप करें, या नीचे दिए गए मेनू का उपयोग करें:",
  "pwa.opera.mobileHomeScreen": "होम स्क्रीन",
  "pwa.opera.mobileStep1": "टैप करें",
  "pwa.opera.mobileStep1b": "Opera के नीचे बार में प्लस (+) आइकन",
  "pwa.opera.mobileStep2": "या टैप करें",
  "pwa.opera.mobileTitle": "Opera में PocketFiler इंस्टॉल करें",
  "pwa.opera.recommendedBrowsers": "इसके बजाय उपयोग करें:",
  "pwa.opera.title": "Opera में उपलब्ध नहीं",
  "qr.clickToExpand": "फुल स्क्रीन देखने के लिए क्लिक करें",
  "qr.copied": "कॉपी हो गया!",
  "qr.copyLink": "लिंक कॉपी करें",
  "qr.description": "यह कोड ग्राहकों या साझेदारों को दिखाएं। जब वे इसे स्कैन करते हैं, तो वे आपसे जुड़ सकते हैं और सेकंडों में डील शुरू कर सकते हैं।",
  "qr.download": "डाउनलोड करें",
  "qr.generate": "QR कोड बनाएं",
  "qr.linkCopied": "लिंक क्लिपबोर्ड पर कॉपी किया गया",
  "qr.primaryLanguage": "मुख्य भाषा",
  "qr.regenerate": "रीसेट",
  "qr.regenerated": "QR कोड पुनर्जनरेट किया गया। पुराने लिंक अब अमान्य हैं।",
  "qr.scanInstructions": "PocketFiler या किसी QR स्कैनर से इस QR को स्कैन करके कनेक्ट करें।",
  "qr.scanToConnect": "कनेक्ट करने के लिए स्कैन करें",
  "qr.share": "साझा करें",
  "qr.title": "अपना PocketFiler QR साझा करें",
  "qr.yourLink": "आपका कनेक्ट लिंक:",
  "recording.completed": "रिकॉर्डिंग पूर्ण",
  "recording.confirmDelete": "इस रिकॉर्डिंग को हटाएं?",
  "recording.delete": "हटाएं",
  "recording.deleted": "रिकॉर्डिंग हटाई गई",
  "recording.download": "डाउनलोड करें",
  "recording.error.delete": "रिकॉर्डिंग हटाने में विफल",
  "recording.error.noCall": "कोई सक्रिय कॉल नहीं। कृपया पहले कॉल में शामिल हों।",
  "recording.error.start": "रिकॉर्डिंग शुरू करने में विफल",
  "recording.error.stop": "रिकॉर्डिंग बंद करने में विफल",
  "recording.failed": "रिकॉर्डिंग विफल",
  "recording.noRecordings": "अभी तक कोई रिकॉर्डिंग नहीं",
  "recording.play": "चलाएं",
  "recording.playback": "रिकॉर्डिंग प्लेबैक",
  "recording.processing": "प्रोसेसिंग हो रही है...",
  "recording.start": "रिकॉर्ड",
  "recording.started": "रिकॉर्डिंग शुरू की गई",
  "recording.stop": "बंद करें",
  "recording.stopped": "रिकॉर्डिंग बंद की गई। प्रोसेसिंग हो रही है...",
  "recording.viewRecordings": "रिकॉर्डिंग देखें",
  "schedule.button": "शेड्यूल",
  "schedule.cancel": "रद्द करें",
  "schedule.chooseDateTime": "कृपया तारीख और समय चुनें",
  "schedule.create": "शेड्यूल करें",
  "schedule.created": "शेड्यूल किया गया",
  "schedule.dateTime": "तारीख और समय",
  "schedule.description": "तारीख और समय चुनें। समय आने पर आप कॉल में शामिल हो सकते हैं।",
  "schedule.title": "कॉल या रिकॉर्डिंग शेड्यूल करें",
  "schedule.type": "प्रकार",
  "schedule.typeCall": "कॉल",
  "schedule.typeRecording": "रिकॉर्डिंग",
  "schedule.upcoming": "आगामी शेड्यूल",
  "settings.profile.accountType": "खाता प्रकार",
  "settings.profile.accountTypeHelp": "वह प्रकार चुनें जो आपका सबसे अच्छा वर्णन करता है",
  "settings.tabs.sharing": "QR साझा करें",
  "support.askAI": "AI से पूछें",
  "support.availableTimes": "उपलब्ध समय",
  "support.booked": "कॉल सफलतापूर्वक शेड्यूल किया गया!",
  "support.bookingConfirmed": "बेहतरीन, मैंने आपका कॉल {time} के लिए शेड्यूल कर दिया है। आपको कॉल लिंक के साथ पुष्टि मिलेगी। क्या कोई और चीज़ है जिसमें मैं मदद कर सकूं?",
  "support.bookingError": "स्लॉट बुक करने में विफल। कृपया दोबारा प्रयास करें।",
  "support.clearChat": "चैट साफ करें",
  "support.error": "मैसेज भेजने में विफल। कृपया दोबारा प्रयास करें।",
  "support.inYourTime": "आपके स्थानीय समय में",
  "support.inputPlaceholder": "अपना प्रश्न टाइप करें...",
  "support.openChat": "AI सहायता खोलें",
  "support.scheduleCall": "सहायता के साथ कॉल शेड्यूल करें",
  "support.scheduleTitle": "सहायता कॉल शेड्यूल करें",
  "support.slotsError": "उपलब्ध समय लोड करने में विफल।",
  "support.subtitle": "PocketFiler के बारे में कुछ भी पूछें",
  "support.title": "AI सहायता",
  "support.welcome": "नमस्ते! मैं PocketFiler AI असिस्टेंट हूं। मैं आपकी इनमें मदद कर सकता हूं:\\n\\n- डील्स बनाना और प्रबंधित करना\\n- हस्ताक्षर के लिए दस्तावेज़ भेजना\\n- QR कनेक्ट फीचर का उपयोग करना\\n- ग्राहकों को आमंत्रित करना\\n- PocketFiler के बारे में कोई अन्य प्रश्न\\n\\nआज मैं आपकी कैसे मदद कर सकता हूं?",
  "support.yourTimezone": "आपका टाइमज़ोन",
  "validation.emailInvalid": "अमान्य ईमेल प्रारूप",
  "validation.emailRequired": "ईमेल आवश्यक है",
  "validation.nameRequired": "नाम आवश्यक है",
  "validation.nameTooLong": "नाम 50 अक्षर से कम होना चाहिए",
  "validation.noteTooLong": "नोट 200 अक्षर से कम होना चाहिए",
  "validation.phoneInvalid": "अमान्य फोन नंबर (10-15 अंक)",
  "validation.phoneRequired": "फोन नंबर आवश्यक है",
  "deals.column.cancelled": "रद्द",
  "deals.column.completed": "पूर्ण",
  "deals.column.disputed": "विवादित",
  "deals.column.escrow_funded": "एस्क्रो वित्तपोषित",
  "deals.column.on_hold": "रुका हुआ",
  "deals.column.pending_documents": "दस्तावेज़ लंबित",
  "deals.column.pending_payment": "भुगतान लंबित",
  "deals.column.pending_signature": "हस्ताक्षर लंबित",
  "deals.column.release_requested": "रिलीज़ अनुरोधित",
  "dashboard.actions.addClient": "क्लाइंट जोड़ें",
  "dashboard.actions.all": "सभी",
  "dashboard.actions.createContract": "कॉन्ट्रैक्ट बनाएं",
  "dashboard.actions.createInvoice": "चालान बनाएं",
  "dashboard.actions.customize": "कस्टमाइज़ करें",
  "dashboard.actions.newDeal": "नई डील",
  "dashboard.actions.scheduleMeeting": "मीटिंग शेड्यूल करें",
  "dashboard.actions.uploadDocument": "दस्तावेज़ अपलोड करें",
  "dashboard.actions.viewAll": "सभी देखें",
  "dashboard.briefing.default": "अभी कुछ भी जरूरी नहीं है। आपका वर्कस्पेस अच्छी स्थिति में है।",
  "dashboard.briefing.title": "दैनिक ब्रीफिंग",
  "dashboard.empty.activity": "कोई हाल की गतिविधि नहीं।",
  "dashboard.empty.deals": "अभी तक कोई डील नहीं है। पाइपलाइन देखने के लिए अपनी पहली डील बनाएं।",
  "dashboard.empty.documents": "सभी दस्तावेज़ अप टू डेट हैं।",
  "dashboard.empty.meetings": "कोई आगामी मीटिंग नहीं।",
  "dashboard.empty.tasks": "कोई खुले कार्य नहीं।",
  "dashboard.greeting.afternoon": "नमस्ते",
  "dashboard.greeting.evening": "शुभ संध्या",
  "dashboard.greeting.morning": "सुप्रभात",
  "dashboard.greeting.subtitle": "यहाँ देखें कि आपके वर्कस्पेस में क्या हो रहा है।",
  "dashboard.stats.documents": "दस्तावेज़",
  "dashboard.stats.invoicesDue": "बकाया चालान",
  "dashboard.stats.meetingsComing": "आगामी मीटिंग",
  "dashboard.stats.tasksDue": "बकाया कार्य",
  "dashboard.stats.unreadMessages": "अपढ़े संदेश",
  "dashboard.widgets.dealPipeline": "डील पाइपलाइन",
  "dashboard.widgets.documentsAttention": "ध्यान चाहने वाले दस्तावेज़",
  "dashboard.widgets.gettingStarted": "शुरुआत करना",
  "dashboard.widgets.quickActions": "त्वरित क्रियाएं",
  "dashboard.widgets.recentActivity": "हाल की गतिविधि",
  "dashboard.widgets.tasks": "कार्य",
  "dashboard.widgets.upcomingMeetings": "आगामी मीटिंग",
  "dashboard.steps.createDeal": "अपना पहला सौदा बनाएं",
  "dashboard.steps.addClient": "एक ग्राहक जोड़ें",
  "dashboard.steps.uploadDocument": "एक दस्तावेज़ अपलोड करें",
  "dashboard.steps.scheduleMeeting": "एक बैठक शेड्यूल करें",
  "dashboard.steps.createInvoice": "एक चालान बनाएं",
  "dashboard.steps.addLogo": "अपना लोगो जोड़ें",
  "dashboard.steps.complete": "पूर्ण",
  "dashboard.time.overdue": "अतिदेय",
  "dashboard.time.today": "आज",
  "dashboard.time.tomorrow": "कल",
  "dashboard.time.noDate": "कोई तारीख नहीं",
  "dashboard.docReason.sent": "भेजा गया, प्रतिक्रिया की प्रतीक्षा",
  "dashboard.docReason.notAnalyzed": "अभी तक विश्लेषण नहीं हुआ",
  "dashboard.docReason.draft": "ड्राफ्ट, अंतिम नहीं",
  "dashboard.docReason.needsReview": "समीक्षा आवश्यक",
  "docViewer.notFound": "दस्तावेज़ नहीं मिला",
  "docViewer.previewUnavailable": "इस फ़ाइल प्रकार के लिए पूर्वावलोकन उपलब्ध नहीं है",
  "docViewer.aiAnalysis": "AI विश्लेषण",
  "docViewer.documentType": "दस्तावेज़ प्रकार",
  "docViewer.summary": "सारांश",
  "docViewer.extractedFields": "निकाले गए क्षेत्र",
  "docViewer.issues": "समस्याएं",
  "docViewer.tags": "टैग",
  "docViewer.noPreviousVersions": "कोई पिछले संस्करण नहीं",
  "docViewer.noActivity": "अभी तक कोई गतिविधि नहीं",
  "auth.forgotPassword.title": "अपना पासवर्ड रीसेट करें",
  "guestSign.loading": "अनुबंध लोड हो रहा है...",
  "guestSign.unableToLoad": "अनुबंध लोड करने में असमर्थ",
  "guestSign.signed": "अनुबंध पर हस्ताक्षर किए गए",
  "guestSign.createOwn": "अपने स्वयं के अनुबंध बनाना और प्रबंधित करना चाहते हैं?",
  "guestSign.secureSign": "सुरक्षित हस्ताक्षर",
  "meeting.ended": "यह बैठक समाप्त हो गई है",
  "meeting.cancelled": "बैठक रद्द की गई",
  "meeting.notFound": "बैठक नहीं मिली",
  "meeting.joiningAs": "के रूप में जुड़ रहे हैं",
  "meeting.yourName": "आपका नाम *",
  "meeting.emailOptional": "ईमेल (वैकल्पिक)",
  "notFound.title": "पृष्ठ नहीं मिला",
  "notFound.dashboard": "Dashboard पर जाएं",
  "notFound.home": "होम",
  "auth.resetPassword.invalidLink": "अमान्य लिंक",
  "auth.resetPassword.title": "नया पासवर्ड सेट करें",
  "templates.category": "श्रेणी",
  "templates.legal": "कानूनी",
  "templates.sales": "बिक्री",
  "templates.services": "सेवाएं",
  "templates.finance": "वित्त",
  "templates.library": "Template Library",
  "templates.libraryDesc": "आपके व्यवसाय के लिए उपयोग के लिए तैयार दस्तावेज़ टेम्प्लेट",
  "templates.noDefault": "कोई डिफ़ॉल्ट टेम्प्लेट आपकी खोज से मेल नहीं खाते।",
  "templates.noCustom": "कोई कस्टम टेम्प्लेट नहीं मिले",
  "templates.delete": "Template हटाएं",
  "templates.cancel": "रद्द करें",
  "uploadRequest.notFound": "अनुरोध नहीं मिला",
  "uploadRequest.error": "कुछ गलत हुआ",
  "uploadRequest.errorDesc": "कृपया बाद में पुनः प्रयास करें या इस अनुरोध को भेजने वाले व्यक्ति से संपर्क करें।",
  "uploadRequest.uploaded": "दस्तावेज़ अपलोड किए गए!",
  "uploadRequest.title": "दस्तावेज़ अपलोड अनुरोध",
  "uploadRequest.fileTypes": "PDF, छवियां, Word दस्तावेज़ - अधिकतम 25MB",
  "verify.verifying": "आपके ईमेल का सत्यापन हो रहा है...",
  "verify.success": "ईमेल सत्यापित!",
  "verify.signIn": "साइन इन करें",
  "verify.alreadyVerified": "पहले से सत्यापित",
  "verify.invalidLink": "अमान्य लिंक",
  "verify.backToLogin": "लॉगिन पर वापस जाएं",
  "documents.documents": "दस्तावेज़",
  "documents.allStatus": "सभी स्थिति",
  "documents.newFolder": "नया फ़ोल्डर",
  "documents.clear": "साफ़ करें",
  "documents.noDocumentsYet": "अभी तक कोई दस्तावेज़ नहीं",
  "documents.status": "स्थिति",
  "documents.type": "प्रकार",
  "documents.uploadedBy": "द्वारा अपलोड किया गया",
  "documents.previewNotAvailable": "पूर्वावलोकन उपलब्ध नहीं",
  "documents.aiAnalysis": "AI विश्लेषण",
  "documents.documentType": "दस्तावेज़ प्रकार",
  "documents.summary": "सारांश",
  "documents.extractedFields": "निकाले गए फ़ील्ड",
  "documents.issues": "समस्याएं",
  "documents.notYetAnalyzed": "अभी तक विश्लेषित नहीं",
  "documents.details": "विवरण",
  "documents.size": "आकार",
  "documents.date": "दिनांक",
  "documents.mimeType": "MIME प्रकार",
  "documents.noTags": "कोई टैग नहीं",
  "documents.changeStatus": "स्थिति बदलें",
  "documents.versionHistory": "संस्करण इतिहास",
  "documents.noPreviousVersions": "कोई पिछले संस्करण नहीं",
  "documents.activityLog": "गतिविधि लॉग",
  "documents.noActivityRecordedYet": "अभी तक कोई गतिविधि रिकॉर्ड नहीं की गई",
  "documents.uploadDocuments": "दस्तावेज़ अपलोड करें",
  "documents.dragAndDropFiles": "फ़ाइलों को ड्रैग और ड्रॉप करें या ब्राउज़ करने के लिए क्लिक करें। PDF, इमेज, Word दस्तावेज़ समर्थित हैं।",
  "documents.shareDocument": "दस्तावेज़ साझा करें",
  "documents.done": "पूर्ण",
  "documents.emailOptional": "ईमेल (वैकल्पिक)",
  "documents.leaveEmptyToJust": "केवल लिंक जनरेट करने के लिए खाली छोड़ें",
  "documents.messageOptional": "संदेश (वैकल्पिक)",
  "documents.cancel": "रद्द करें",
  "documents.requestDocuments": "दस्तावेज़ अनुरोध करें",
  "documents.sendASecureUpload": "ईमेल के द्वारा क्लाइंट को एक सुरक्षित अपलोड लिंक भेजें।",
  "documents.clientEmail": "क्लाइंट ईमेल *",
  "documents.clientName": "क्लाइंट नाम",
  "documents.requestedDocuments": "अनुरोधित दस्तावेज़ *",
  "documents.renameFolder": "फ़ोल्डर का नाम बदलें",
  "documents.selectADestinationFolder": "एक गंतव्य फ़ोल्डर चुनें।",
  "documents.deleteDocument": "दस्तावेज़ हटाएं?",
  "settings.individual": "व्यक्तिगत",
  "settings.business": "व्यवसाय",
  "settings.buyer": "खरीदार",
  "settings.seller": "विक्रेता",
  "settings.chooseYourPreferredTheme": "अपनी पसंदीदा थीम चुनें",
  "settings.light": "हल्का",
  "settings.dark": "गहरा",
  "settings.system": "सिस्टम",
  "settings.manufacturing": "निर्माण",
  "settings.insurance": "बीमा",
  "settings.realEstate": "Real Estate",
  "settings.automotive": "ऑटोमोटिव",
  "settings.importexport": "आयात/निर्यात",
  "settings.other": "अन्य",
  "settings.brandingWhitelabel": "ब्रांडिंग और White-Label",
  "settings.customizeThePocketfilerExperience": "अपने क्लाइंट्स के लिए PocketFiler अनुभव को अनुकूलित करें।",
  "settings.organizationLogo": "संगठन लोगो",
  "settings.provideADirectLink": "अपने पारदर्शी PNG या SVG लोगो का सीधा लिंक प्रदान करें।",
  "settings.primaryThemeColor": "मुख्य थीम रंग",
  "settings.selectAHexColor": "अपने ब्रांड के मुख्य एक्सेंट्स को दर्शाने के लिए एक hex कलर कोड चुनें।",
  "settings.accentHoverColor": "एक्सेंट / होवर रंग",
  "settings.selectAHexColor1": "होवर स्थितियों, हाइलाइट्स और एक्सेंट तत्वों के लिए एक hex रंग चुनें।",
  "settings.customDomain": "कस्टम डोमेन",
  "settings.ensureYouConfigureA": "सुनिश्चित करें कि आप pocketfiler.com को इंगित करने वाला CNAME रिकॉर्ड कॉन्फ़िगर करें।",
  "settings.cancellationScheduled": "रद्दीकरण निर्धारित",
  "settings.yourLastPaymentFailed": "आपका अंतिम भुगतान असफल हुआ। पहुंच बनाए रखने के लिए कृपया अपनी भुगतान विधि अपडेट करें।",
  "settings.chooseYourPlan": "अपना प्लान चुनें",
  "settings.monthly": "मासिक",
  "settings.save20": "20% बचाएं",
  "settings.current": "वर्तमान",
  "settings.popular": "लोकप्रिय",
  "settings.contactSales": "बिक्री से संपर्क करें",
  "settings.googleCalendar": "Google Calendar",
  "settings.syncYourPocketfilerMeetings": "अपनी PocketFiler मीटिंग्स को Google Calendar के साथ सिंक करें",
  "settings.settingsPageErrorDebug": "सेटिंग्स पेज त्रुटि (debug)",
  "invoices.createInvoice": "इनवॉइस बनाएं",
  "invoices.createANewInvoice": "क्लाइंट के लिए नया इनवॉइस बनाएं",
  "invoices.selectClient": "क्लाइंट चुनें",
  "invoices.dueDate": "देय तिथि",
  "invoices.clientName": "क्लाइंट नाम",
  "invoices.clientEmail": "क्लाइंट ईमेल",
  "invoices.lineItems": "लाइन आइटम",
  "invoices.description": "विवरण",
  "invoices.qty": "मात्रा",
  "invoices.price": "मूल्य",
  "invoices.tax": "कर %",
  "invoices.total": "कुल",
  "invoices.subtotal": "उप-योग:",
  "invoices.discount": "छूट:",
  "invoices.tax1": "कर:",
  "invoices.total1": "कुल:",
  "invoices.notesOptional": "टिप्पणियां (वैकल्पिक)",
  "invoices.invoices": "इनवॉइसेस",
  "invoices.manageAndTrackYour": "अपने इनवॉइसेस का प्रबंधन और ट्रैकिंग करें",
  "invoices.totalInvoiced": "कुल इनवॉइस्ड",
  "invoices.paid": "भुगतान किया गया",
  "invoices.outstanding": "बकाया",
  "invoices.totalInvoices": "कुल इनवॉइसेस",
  "invoices.allInvoices": "सभी इनवॉइसेस",
  "invoices.myInvoices": "मेरे इनवॉयसेस",
  "invoices.receivedInvoices": "प्राप्त इनवॉयसेस",
  "invoices.noInvoicesYet": "अभी तक कोई इनवॉयस नहीं",
  "meetings.join": "शामिल हों",
  "meetings.end": "समाप्त करें",
  "meetings.meetingTitle": "मीटिंग शीर्षक",
  "meetings.date": "दिनांक",
  "meetings.time": "समय",
  "meetings.duration": "अवधि",
  "meetings.repeat": "दोहराएं",
  "meetings.doesNotRepeat": "दोहराया नहीं जाता",
  "meetings.weekly": "साप्ताहिक",
  "meetings.every2Weeks": "प्रत्येक 2 सप्ताह",
  "meetings.monthly": "मासिक",
  "meetings.invitePeopleOptional": "लोगों को आमंत्रित करें (वैकल्पिक)",
  "meetings.cancel": "रद्द करें",
  "meetings.meetings": "मीटिंग्स",
  "companyprofile.companyProfile": "कंपनी प्रोफाइल",
  "companyprofile.manageYourBusinessProfile": "अपनी व्यावसायिक प्रोफाइल और टीम का प्रबंधन करें",
  "companyprofile.publicProfile": "सार्वजनिक प्रोफाइल",
  "companyprofile.basicInformation": "मूलभूत जानकारी",
  "companyprofile.essentialDetailsAboutYour": "आपकी कंपनी के बारे में आवश्यक विवरण",
  "companyprofile.companyName": "कंपनी का नाम",
  "companyprofile.tagline": "टैगलाइन",
  "companyprofile.industry": "उद्योग",
  "companyprofile.companyType": "कंपनी का प्रकार",
  "companyprofile.description": "विवरण",
  "companyprofile.companyDetails": "कंपनी विवरण",
  "companyprofile.additionalInformationAboutYour": "आपके व्यवसाय के बारे में अतिरिक्त जानकारी",
  "companyprofile.yearEstablished": "स्थापना वर्ष",
  "companyprofile.numberOfEmployees": "कर्मचारियों की संख्या",
  "companyprofile.certifications": "प्रमाणपत्र",
  "companyprofile.enterCertificationsSeparatedBy": "प्रमाणपत्रों को कॉमा से अलग करके दर्ज करें",
  "companyprofile.languagesSpoken": "बोली जाने वाली भाषाएं",
  "companyprofile.shippingRegions": "शिपिंग क्षेत्र",
  "companyprofile.contactInformation": "संपर्क जानकारी",
  "companyprofile.howPotentialPartnersCan": "संभावित साझेदार आपसे कैसे संपर्क कर सकते हैं",
  "companyprofile.website": "वेबसाइट",
  "companyprofile.email": "ईमेल",
  "companyprofile.phone": "फोन",
  "companyprofile.country": "देश",
  "companyprofile.city": "शहर",
  "companyprofile.address": "पता",
  "companyprofile.teamMembers": "टीम सदस्य",
  "companyprofile.manageUsersWithinYour": "अपने संगठन के भीतर उपयोगकर्ताओं का प्रबंधन करें",
  "companyprofile.role": "भूमिका",
  "companyprofile.admin": "प्रशासक",
  "companyprofile.member": "सदस्य",
  "companyprofile.viewer": "दर्शक",
  "companyprofile.titleOptional": "पदनाम (वैकल्पिक)",
  "companyprofile.name": "नाम",
  "companyprofile.title": "पदनाम",
  "companyprofile.status": "स्थिति",
  "companyprofile.actions": "क्रियाएं",
  "companyprofile.owner": "स्वामी",
  "companyprofile.copyInviteLink": "निमंत्रण लिंक कॉपी करें",
  "companyprofile.removeMember": "सदस्य को हटाएं",
  "companyprofile.removeTeamMember": "टीम सदस्य को हटाएं",
  "companyprofile.cancel": "रद्द करें",
  "products.productsServices": "उत्पाद और सेवाएं",
  "products.description": "विवरण",
  "products.pricing": "मूल्य निर्धारण",
  "products.price": "मूल्य",
  "products.unit": "इकाई",
  "products.details": "विवरण",
  "products.minOrderQty": "न्यूनतम आदेश मात्रा",
  "products.leadTime": "लीड टाइम",
  "products.category": "श्रेणी",
  "products.currency": "मुद्रा",
  "products.leadTimeDays": "लीड टाइम (दिन)",
  "products.active": "सक्रिय",
  "products.showInCatalog": "कैटलॉग में दिखाएं",
  "products.cancel": "रद्द करें",
  "developersettings.reveal": "प्रकट करें",
  "developersettings.copy": "कॉपी करें",
  "developersettings.hide": "छुपाएं",
  "developersettings.securityWarning": "सुरक्षा चेतावनी",
  "developersettings.neverShareThisKey": "इस key को कभी भी सार्वजनिक रूप से या client-side code में साझा न करें",
  "developersettings.anyoneWithThisKey": "इस key वाला कोई भी व्यक्ति आपके डेटा को पढ़ और संशोधित कर सकता है",
  "developersettings.ifCompromisedRevokeImmediately": "यदि समझौता हो जाए, तो तुरंत रद्द करें और एक नई key बनाएं",
  "developersettings.iUnderstandAndAccept": "मैं समझता हूं और इस key की सुरक्षा की जिम्मेदारी स्वीकार करता हूं",
  "developersettings.cancel": "रद्द करें",
  "developersettings.revealKey": "Key प्रकट करें",
  "developersettings.accessDenied": "पहुंच मना",
  "developersettings.onlyBusinessAccountsHave": "केवल व्यावसायिक खातों की Developer Settings तक पहुंच है।",
  "developersettings.developerOverview": "Developer अवलोकन",
  "developersettings.manageYourApiKeys": "तृतीय-पक्ष एकीकरण के लिए अपनी API keys और Webhook endpoints का प्रबंधन करें।",
  "developersettings.secretApiKeys": "गुप्त API Keys",
  "developersettings.interactiveApiDocumentationRarr": "इंटरैक्टिव API Documentation &rarr;",
  "developersettings.name": "नाम",
  "developersettings.key": "Key",
  "developersettings.createdAt": "बनाया गया",
  "developersettings.status": "स्थिति",
  "developersettings.actions": "क्रियाएं",
  "developersettings.webhookEndpoints": "Webhook Endpoints",
  "developersettings.url": "URL",
  "developersettings.events": "Events",
  "developersettings.description": "विवरण",
  "developersettings.done": "पूर्ण",
  "developersettings.addWebhookEndpoint": "Webhook Endpoint जोड़ें",
  "developersettings.payloadUrl": "Payload URL",
  "developersettings.eventsToSend": "भेजने वाले Events",
  "developersettings.sendMeEverything": "मुझे सब कुछ भेजें (*)",
  "developersettings.dealStatusChangedDealstatuschanged": "Deal Status Changed (deal.status_changed)",
  "developersettings.documentUploadedDocumentuploaded": "Document Uploaded (document.uploaded)",
  "developersettings.descriptionOptional": "विवरण (वैकल्पिक)",
  "analytics.noDataAvailableFor": "इस अवधि के लिए कोई डेटा उपलब्ध नहीं है।",
  "analytics.noDealsFound": "कोई deals नहीं मिले।",
  "analytics.noClientDataAvailable": "इस अवधि के लिए कोई client डेटा उपलब्ध नहीं है।",
  "analytics.client": "Client",
  "analytics.invoices": "Invoices",
  "analytics.revenue": "Revenue",
  "analytics.totalPipeline": "Total Pipeline",
  "analytics.noRecentActivityFor": "इस अवधि के लिए कोई हाल की गतिविधि नहीं।",
  "analytics.pipelineOverview": "Pipeline Overview",
  "analytics.goToDeals": "Deals पर जाएं",
  "analytics.analyticsDashboard": "Analytics Dashboard",
  "analytics.trackYourBusinessPerformance": "अपने व्यवसाय की प्रदर्शन और insights को ट्रैक करें",
  "analytics.last7Days": "पिछले 7 दिन",
  "analytics.last30Days": "पिछले 30 दिन",
  "analytics.last90Days": "पिछले 90 दिन",
  "analytics.lastYear": "पिछला वर्ष",
  "analytics.overview": "Overview",
  "analytics.myPerformance": "मेरा प्रदर्शन",
  "analytics.currentDealsByStatus": "Status के अनुसार वर्तमान deals",
  "analytics.revenueTrendsOverLast": "पिछले 6 महीनों में Revenue के रुझान",
  "analytics.accountsGeneratingTheMost": "सबसे अधिक revenue उत्पन्न करने वाले accounts",
  "analytics.currentCashFlowOverview": "वर्तमान Cash Flow Overview",
  "analytics.latestBusinessActivitiesAnd": "नवीनतम व्यावसायिक गतिविधियां और अपडेट",
  "compliance.complianceCenter": "Compliance Center",
  "compliance.hsCodesTariffsSanctions": "HS codes, tariffs, sanctions screening, और export controls",
  "compliance.hsCodeClassification": "HS Code Classification",
  "compliance.productDescription": "Product Description",
  "compliance.tariffCalculator": "Tariff Calculator",
  "compliance.estimateImportDutiesBased": "HS code और trade route के आधार पर import duties का अनुमान लगाएं।",
  "compliance.hsCode": "HS Code",
  "compliance.declaredValueUsd": "Declared Value (USD)",
  "compliance.originCountry": "Origin Country",
  "compliance.destinationCountry": "Destination Country",
  "compliance.dutyRate": "Duty Rate:",
  "compliance.totalRate": "Total Rate:",
  "compliance.estDuty": "Est. Duty:",
  "compliance.totalEstCost": "Total Est. Cost:",
  "compliance.tradeAgreements": "Trade Agreements:",
  "compliance.sanctionsScreening": "Sanctions Screening",
  "compliance.screenEntitiesAgainstOfac": "OFAC SDN list और country sanctions के विरुद्ध entities की screening करें।",
  "compliance.entityName": "Entity Name",
  "compliance.type": "Type",
  "compliance.company": "Company",
  "compliance.individual": "Individual",
  "compliance.vessel": "Vessel",
  "compliance.countryOptional": "Country (वैकल्पिक)",
  "compliance.usSanctionedCountries": "US Sanctioned Countries",
  "compliance.exportControlCheck": "Export Control Check",
  "compliance.aipoweredEaritarClassificationGuidance": "AI-powered EAR/ITAR classification guidance। यह कानूनी सलाह नहीं है।",
  "compliance.producttechnologyDescription": "Product/Technology Description",
  "compliance.hsCodeOptional": "HS Code (वैकल्पिक)",
  "compliance.endUseOptional": "End Use (वैकल्पिक)",
  "compliance.licenseRequired": "License Required",
  "compliance.recommendations": "Recommendations:",
  "compliance.complianceHistory": "Compliance History",
  "compliance.recentComplianceChecksFor": "आपके संगठन के लिए हाल की compliance checks।",
  "compliance.noComplianceChecksYet": "अभी तक कोई compliance checks नहीं। ऊपर अपनी पहली check चलाएं।",
  "intelligence.marketIntelligence": "Market Intelligence",
  "intelligence.anonymizedTradeDataAnd": "PocketFiler platform से anonymized trade data और benchmarks",
  "intelligence.demandByCategory": "Category के अनुसार Demand",
  "intelligence.whatBuyersAreSourcing": "Buyers platform पर क्या sourcing कर रहे हैं (पिछले 90 दिन)",
  "intelligence.noDemandDataYet": "अभी तक कोई demand data नहीं। जैसे ही RFQs platform पर बनाए जाते हैं, data भरा जाता है।",
  "intelligence.byIndustry": "Industry के अनुसार",
  "intelligence.noSupplierDataYet": "अभी तक कोई supplier data नहीं।",
  "intelligence.byCountry": "Country के अनुसार",
  "intelligence.byType": "Type के अनुसार",
  "intelligence.byVerification": "Verification के अनुसार",
  "intelligence.noDataYet": "अभी तक कोई डेटा नहीं।",
  "intelligence.yourPerformanceVsPlatform": "Platform के मुकाबले आपका प्रदर्शन",
  "intelligence.seeHowYouStack": "देखें कि आप platform averages के मुकाबले कैसे खड़े हैं",
  "intelligence.completeSomeDealsTo": "Benchmarks देखने के लिए कुछ deals पूरे करें।",
  "virtualoffices.virtualOffices": "Virtual Offices",
  "virtualoffices.manageYourBrandedWorkspaces": "अपने branded workspaces को manage करें",
  "virtualoffices.officeName": "Office Name",
  "virtualoffices.industry": "Industry",
  "virtualoffices.languagesServed": "Languages Served",
  "virtualoffices.descriptionOptional": "विवरण (वैकल्पिक)",
  "virtualoffices.documentChecklist": "Document Checklist",
  "virtualoffices.languages": "Languages",
  "tasks.tasks": "Tasks",
  "tasks.noTasksYet": "अभी तक कोई tasks नहीं",
  "tasks.dragTasksHere": "Tasks को यहां drag करें",
  "tasks.createNewTask": "नया Task बनाएं",
  "tasks.descriptionOptional": "विवरण (वैकल्पिक)",
  "tasks.relatedDealOptional": "Related Deal (वैकल्पिक)",
  "tasks.noDealAttached": "कोई deal attached नहीं",
  "tasks.assignees": "Assignees",
  "tasks.noTeamMembersAvailable": "कोई team members उपलब्ध नहीं। केवल active members को assign किया जा सकता है।",
  "tasks.cancel": "रद्द करें",
  "tasks.description": "विवरण",
  "tasks.status": "Status",
  "tasks.relatedDeal": "Related deal",
  "tasks.noAssignees": "कोई assignees नहीं",
  "tasks.areYouAbsolutelySure": "क्या आप बिल्कुल निश्चित हैं?",
  "events.events": "Events",
  "events.tradeShowsWebinarsAnd": "व्यापार प्रदर्शनी, webinars, और नेटवर्किंग events",
  "events.createEvent": "Event बनाएं",
  "events.title": "शीर्षक",
  "events.description": "विवरण",
  "events.category": "श्रेणी",
  "events.type": "प्रकार",
  "events.locationUrl": "स्थान / URL",
  "events.startDateTime": "प्रारंभ दिनांक और समय",
  "events.endDateTime": "समाप्ति दिनांक और समय",
  "events.maxAttendeesOptional": "अधिकतम उपस्थित लोग (वैकल्पिक)",
  "events.cancel": "रद्द करें",
  "events.allCategories": "सभी श्रेणियां",
  "events.noEventsFoundCreate": "कोई events नहीं मिले। पहला event बनाएं!",
  "events.featured": "विशेष",
  "events.previous": "पिछला",
  "events.next": "अगला",
  "status.pendingDocuments": "दस्तावेज़ लंबित",
  "status.pendingSignature": "हस्ताक्षर लंबित",
  "status.pendingPayment": "भुगतान लंबित",
  "status.completed": "पूर्ण",
  "status.updated": "अपडेट किया गया",
  "status.onHold": "रोक पर",
  "activity.deal": "डील",
  "activity.action.analyzed": "विश्लेषित",
  "activity.action.uploaded": "अपलोड किया गया",
  "activity.action.downloaded": "डाउनलोड किया गया",
  "activity.action.previewed": "पूर्वावलोकन किया गया",
  "activity.action.shared": "साझा किया गया",
  "activity.action.status_changed": "स्थिति बदली गई",
  "activity.action.updated": "अपडेट किया गया",
  "activity.action.created": "बनाया गया",
  "activity.action.archived": "संग्रहीत",
  "activity.action.restored": "पुनर्स्थापित",
  "analytics.totalRevenue": "कुल राजस्व",
  "analytics.totalDeals": "कुल सौदे",
  "analytics.conversionRate": "रूपांतरण दर",
  "analytics.avgDealValue": "औसत सौदा मूल्य",
  "analytics.dealPipeline": "सौदा पाइपलाइन",
  "analytics.monthlyRevenue": "मासिक राजस्व",
  "analytics.topClientsByRevenue": "राजस्व के अनुसार शीर्ष ग्राहक",
  "analytics.invoiceHealth": "चालान स्वास्थ्य",
  "analytics.paid": "भुगतान किया गया",
  "analytics.pendingPayment": "लंबित भुगतान",
  "companyprofile.saveProfile": "प्रोफाइल सहेजें",
  "companyprofile.makeVisible": "अपनी कंपनी को निर्देशिका में दृश्यमान बनाएं",
  "companyprofile.tab.basicInfo": "मूलभूत जानकारी",
  "companyprofile.tab.details": "विवरण",
  "companyprofile.tab.contact": "संपर्क",
  "companyprofile.tab.team": "टीम",
  "companyprofile.tab.verification": "सत्यापन",
  "companyprofile.selectType": "प्रकार चुनें",
  "companyprofile.describePlaceholder": "अपनी कंपनी, उत्पाद और सेवाओं का वर्णन करें...",
  "companyprofile.industry.other": "अन्य",
  "companyprofile.preview": "पूर्वावलोकन",
  "companyprofile.ph.companyName": "Your Company Inc.",
  "companyprofile.ph.tagline": "गुणवत्तापूर्ण उत्पाद, वैश्विक पहुंच",
  "companyprofile.ph.selectIndustry": "उद्योग चुनें",
  "companyprofile.ph.selectSize": "आकार चुनें",
  "companyprofile.ph.certifications": "ISO 9001, CE, FDA (अल्पविराम से अलग करें)",
  "companyprofile.ph.languages": "अंग्रेजी, स्पेनिश, चीनी",
  "companyprofile.ph.exportRegions": "उत्तरी अमेरिका, यूरोप, एशिया",
  "companyprofile.ph.selectCountry": "देश चुनें",
  "companyprofile.ph.city": "Los Angeles",
  "companyprofile.ph.teamName": "टीम सदस्य का नाम",
  "companyprofile.ph.addTitle": "शीर्षक जोड़ें...",
  "companyprofile.inviteTeamMember": "टीम सदस्य को आमंत्रित करें",
  "companyprofile.invitationSent": "निमंत्रण सफलतापूर्वक भेजा गया",
  "virtualoffices.newOffice": "नया ऑफिस",
  "virtualoffices.createOffice": "वर्चुअल ऑफिस बनाएं",
  "virtualoffices.reviewChecklist": "दस्तावेज़ जांच सूची की समीक्षा करें",
  "virtualoffices.setupDesc": "अपने व्यवसाय के लिए एक नया ब्रांडेड कार्यक्षेत्र स्थापित करें",
  "virtualoffices.customizeDesc": "ग्राहकों से आवश्यक दस्तावेज़ों को अनुकूलित करें",
  "virtualoffices.ph.officeName": "उदाहरण: गार्सिया इंश्योरेंस - ऑटो पॉलिसी",
  "virtualoffices.ph.description": "अपने ऑफिस के फोकस का वर्णन करें...",
  "virtualoffices.ph.addDocument": "कस्टम दस्तावेज़ जोड़ें...",
  "virtualoffices.generating": "जेनरेट हो रहा है...",
  "virtualoffices.aiChecklist": "एआई-जेनरेटेड जांच सूची",
  "virtualoffices.clients": "ग्राहक",
  "virtualoffices.pending": "लंबित",
  "virtualoffices.invite": "आमंत्रित करें",
  "virtualoffices.ind.manufacturing": "विनिर्माण",
  "virtualoffices.ind.insurance": "बीमा",
  "virtualoffices.ind.real_estate": "रियल एस्टेट",
  "virtualoffices.ind.automotive": "ऑटोमोटिव",
  "virtualoffices.ind.import_export": "आयात/निर्यात",
  "virtualoffices.ind.other": "अन्य",
  "messages.conversations": "वार्तालाप",
  "messages.searchPlaceholder": "संदेश खोजें...",
  "messages.noConversations": "कोई वार्तालाप नहीं",
  "messages.send": "भेजें",
  "messages.selectConversation": "एक वार्तालाप चुनें",
  "messages.selectConversationDesc": "चैटिंग शुरू करने के लिए साइडबार से एक वार्तालाप चुनें",
  "messages.support": "सहायता",
  "messages.client": "ग्राहक",
  "messages.deal": "सौदा",
  "meetings.subtitle": "वीडियो बैठकों को निर्धारित और प्रबंधित करें",
  "meetings.upcoming": "आगामी",
  "meetings.past": "पिछली",
  "meetings.schedule": "निर्धारित करें",
  "meetings.startInstant": "तत्काल प्रारंभ करें",
  "meetings.startNow": "अभी प्रारंभ करें",
  "meetings.noPast": "कोई पिछली बैठक नहीं",
  "meetings.noUpcoming": "कोई आगामी बैठक नहीं",
  "meetings.createMeeting": "बैठक बनाएं",
  "meetings.startInstantMeeting": "तत्काल बैठक प्रारंभ करें",
  "meetings.scheduleMeeting": "बैठक निर्धारित करें",
  "meetings.scheduleDesc": "एक वीडियो बैठक निर्धारित करें और निमंत्रण भेजें।",
  "meetings.invitePeople": "लोगों को आमंत्रित करें (वैकल्पिक)",
  "meetings.15min": "15 मिनट",
  "meetings.30min": "30 मिनट",
  "meetings.45min": "45 मिनट",
  "meetings.allowRecording": "रिकॉर्डिंग की अनुमति दें",
  "meetings.recordingDesc": "होस्ट को इस बैठक को रिकॉर्ड करने में सक्षम बनाता है",
  "meetings.waitingRoom": "प्रतीक्षा कक्ष",
  "meetings.waitingRoomDesc": "प्रतिभागियों को शामिल होने से पहले होस्ट द्वारा स्वीकार किया जाना आवश्यक है",
  "meetings.emailPlaceholder": "email@example.com",
  "meetings.cancelConfirm": "इस बैठक को रद्द करें?",
  "meetings.cancelMeeting": "बैठक रद्द करें",
  "documents.title": "दस्तावेज़",
  "documents.viewAll": "सभी देखें",
  "documents.archived": "संग्रहीत",
  "documents.requestDocs": "दस्तावेज़ मांगें",
  "documents.upload": "अपलोड",
  "documents.allDocuments": "सभी दस्तावेज़",
  "documents.searchPlaceholder": "दस्तावेज़ खोजें...",
  "documents.addTag": "टैग जोड़ें...",
  "documents.uploadDesc": "फ़ाइलें खींचें और छोड़ें या ब्राउज़ करने के लिए क्लिक करें। PDF, छवियां, Word दस्तावेज़ समर्थित हैं।",
  "documents.emailPlaceholder": "client@example.com",
  "documents.shareMsgPlaceholder": "यहां आपका मांगा गया दस्तावेज़ है...",
  "documents.requestDesc": "ईमेल के माध्यम से क्लाइंट को सुरक्षित अपलोड लिंक भेजें।",
  "documents.namePlaceholder": "जॉन डो",
  "documents.requestMsgPlaceholder": "कृपया निम्नलिखित दस्तावेज़ अपलोड करें...",
  "documents.folderName": "फ़ोल्डर नाम",
  "documents.selectDestination": "गंतव्य फ़ोल्डर चुनें।",
  "documents.statusUploaded": "अपलोड किया गया",
  "documents.statusAnalyzed": "विश्लेषित",
  "documents.statusArchived": "संग्रहीत",
  "documents.allTypes": "सभी प्रकार",
  "documents.inArchive": "संग्रह में",
  "templates.allTemplates": "सभी टेम्प्लेट",
  "templates.editTemplate": "टेम्प्लेट संपादित करें",
  "templates.createCustomTemplate": "कस्टम टेम्प्लेट बनाएं",
  "templates.editDesc": "अपना दस्तावेज़ टेम्प्लेट अपडेट करें",
  "templates.createDesc": "अपना पुन: उपयोग योग्य दस्तावेज़ टेम्प्लेट बनाएं",
  "templates.ph.templateName": "उदा., कस्टम NDA",
  "templates.ph.description": "टेम्प्लेट का संक्षिप्त विवरण",
  "templates.ph.content": "अपनी टेम्प्लेट सामग्री यहां दर्ज करें...",
  "templates.saving": "सहेजा जा रहा है...",
  "templates.creating": "बनाया जा रहा है...",
  "templates.saveChanges": "परिवर्तन सहेजें",
  "templates.createTemplate": "टेम्प्लेट बनाएं",
  "templates.searchPlaceholder": "टेम्प्लेट खोजें...",
  "templates.popularTemplates": "लोकप्रिय टेम्प्लेट",
  "templates.defaultTemplates": "डिफ़ॉल्ट टेम्प्लेट",
  "templates.deleteTemplate": "टेम्प्लेट हटाएं",
  "templates.preview": "पूर्वावलोकन",
  "templates.description": "विवरण",
  "products.searchPlaceholder": "उत्पाद खोजें...",
  "products.ph.service": "परामर्श सेवाएं",
  "products.ph.product": "विजेट प्रो 3000",
  "products.selectCategory": "श्रेणी चुनें",
  "products.ph.describe": "अपने उत्पाद या सेवा का विवरण दें...",
  "products.noMatches": "कोई मेल नहीं मिला",
  "products.noProducts": "अभी तक कोई उत्पाद या सेवा नहीं",
  "products.serviceDetails": "सेवा विवरण",
  "products.productDetails": "उत्पाद विवरण",
  "products.inactive": "निष्क्रिय",
  "products.deleteConfirm": "इस आइटम को हटाएं?",
  "products.saveChanges": "परिवर्तन सुरक्षित करें",
  "products.addItem": "आइटम जोड़ें",
  "products.priceOnRequest": "अनुरोध पर मूल्य",
  "products.perUnit": "प्रति इकाई",
  "tasks.searchPlaceholder": "कार्य खोजें...",
  "tasks.ph.title": "उदाहरण: कानूनी दस्तावेजों की समीक्षा करें",
  "tasks.ph.description": "इस कार्य में अधिक संदर्भ जोड़ें...",
  "tasks.selectDeal": "संलग्न करने के लिए सौदा चुनें",
  "tasks.noTasks": "इस कॉलम में कोई कार्य नहीं",
  "tasks.deleteTask": "कार्य हटाएं",
  "settings.tabs.branding": "ब्रांडिंग",
  "settings.tabs.payments": "भुगतान",
  "settings.tabs.plan": "योजना",
  "settings.tabs.integrations": "एकीकरण",
  "settings.appearance": "रूप-रंग",
  "settings.saveBranding": "ब्रांडिंग सहेजें",
  "settings.yourPlan": "आपकी योजना",
  "settings.ph.logoUrl": "https://example.com/logo.png",
  "settings.ph.customDomain": "deals.yourcompany.com",
  "settings.calendarFeedGenerated": "कैलेंडर फीड URL जेनरेट किया गया!",
  "settings.plan.free": "निःशुल्क",
  "settings.plan.pro": "प्रो",
  "settings.plan.smallBusiness": "लघु व्यवसाय",
  "settings.plan.businessPro": "बिजनेस प्रो",
  "settings.plan.scale": "स्केल",
  "settings.plan.enterprise": "एंटरप्राइज",
  "dealroom.meetings": "बैठकें",
  "dealroom.startMeeting": "बैठक प्रारंभ करें",
  "dealroom.noMeetings": "इस सौदे से अभी तक कोई बैठक जुड़ी नहीं है",
  "dealroom.noMeetingsDesc": "आरंभ करने के लिए एक बैठक प्रारंभ करें या एक निर्धारित करें",
  "dealroom.failedCreateMeeting": "बैठक बनाने में असफल",
  "dealroom.finalizedContract": "अंतिम अनुबंध — हस्ताक्षर के लिए तैयार",
  "dealroom.previewNotSupported": "पूर्वावलोकन समर्थित नहीं है",
  "dealroom.aiMayTakeMoment": "इसमें कुछ समय लग सकता है।",
  "dealroom.aiAnalysisGenerated": "निम्नलिखित दस्तावेजों के लिए AI विश्लेषण तैयार किया गया है:",
  "dealroom.docsUnanalyzed": "निम्नलिखित दस्तावेज अभी भी अविश्लेषित हैं:",
  "dealroom.analyzingDocs": "दस्तावेजों का विश्लेषण कर रहे हैं...",
  "dealroom.finalizeWarning": "इस क्रिया को पूर्ववत नहीं किया जा सकता। सौदे की स्थिति हस्ताक्षर लंबित में बदल जाएगी और सभी पक्ष अनुबंध पर हस्ताक्षर कर सकेंगे।",
  "dealroom.cannotRevert": "हस्ताक्षर लंबित से वापस नहीं जा सकते",
  "compliance.ph.productDesc": "उदाहरण: स्टेनलेस स्टील बोल्ट, M10 x 50mm...",
  "compliance.ph.exportDesc": "निर्यात किए जाने वाले उत्पाद या तकनीक का वर्णन करें...",
  "compliance.select": "चुनें...",
  "compliance.selectCountry": "देश चुनें...",
  "events.tradeShow": "व्यापार प्रदर्शनी",
  "events.webinar": "वेबिनार",
  "events.networking": "नेटवर्किंग",
  "events.conference": "सम्मेलन",
  "events.workshop": "कार्यशाला",
  "events.ph.title": "कार्यक्रम का शीर्षक",
  "events.ph.location": "स्थल का पता या मीटिंग URL",
  "events.ph.maxAttendees": "असीमित के लिए खाली छोड़ें",
  "events.searchPlaceholder": "कार्यक्रम खोजें...",
  "events.cancelRsvp": "RSVP रद्द करें",
  "events.rsvp": "RSVP",
  "rfq.expired": "समाप्त",
  "rfq.createRfq": "कोटेशन के लिए अनुरोध बनाएं",
  "rfq.visibility": "दृश्यता",
  "rfq.public": "सार्वजनिक - सभी आपूर्तिकर्ता देख सकते हैं",
  "rfq.private": "निजी - केवल आमंत्रित",
  "rfq.quantity": "मात्रा",
  "rfq.unit": "इकाई",
  "rfq.pieces": "टुकड़े",
  "rfq.kilograms": "किलोग्राम",
  "rfq.meters": "मीटर",
  "rfq.squareMeters": "वर्ग मीटर",
  "rfq.units": "इकाइयां",
  "rfq.sets": "सेट",
  "rfq.boxes": "बॉक्स",
  "rfq.deliveryLocation": "डिलीवरी स्थान",
  "rfq.deliveryDeadline": "डिलीवरी की अंतिम तिथि",
  "rfq.specialRequirements": "विशेष आवश्यकताएं",
  "rfq.title": "कोटेशन के लिए अनुरोध",
  "rfq.subtitle": "सोर्सिंग अनुरोध देखें या अपना स्वयं का पोस्ट करें",
  "rfq.rfqsPosted": "RFQ पोस्ट किए गए",
  "rfq.openRfqs": "खुले RFQ",
  "rfq.quotesSent": "भेजे गए कोटेशन",
  "rfq.winRate": "जीत दर",
  "rfq.allCategories": "सभी श्रेणियां",
  "rfq.noRfqsFound": "कोई RFQ नहीं मिले",
  "rfq.noRfqsYet": "अभी तक कोई RFQ नहीं",
  "meetings.biweekly": "हर 2 सप्ताह",
  "meetings.cancelSeries": "पूरी श्रृंखला रद्द करें",
  "meetings.cancelThisMeeting": "यह मीटिंग रद्द करें",
  "meetings.nextInSeries": "श्रृंखला में अगला",
  "nav.contractTemplates": "अनुबंध",
  "contracts.title": "अनुबंध टेम्पलेट",
  "contracts.subtitle": "AI-संचालित कानूनी दस्तावेज़ निर्माण। शुरू करने के लिए एक टेम्पलेट चुनें।",
  "documents.create": "बनाएं",
  "createDoc.untitledDocument": "शीर्षकहीन दस्तावेज़",
  "createDoc.save": "सहेजें",
  "createDoc.export": "निर्यात",
  "createDoc.aiAssist": "AI सहायक",
  "createDoc.generate": "उत्पन्न करें",
  "createDoc.generating": "उत्पन्न हो रहा है...",
  "createDoc.cancel": "रद्द करें",
  "createDoc.translate": "अनुवाद",
  "createDoc.translateTitle": "दस्तावेज़ का अनुवाद",
  "createDoc.translateTo": "में अनुवाद करें",
  "createDoc.translateNow": "अनुवाद करें",
  "createDoc.translating": "अनुवाद हो रहा है...",
  "createDoc.translated": "दस्तावेज़ का अनुवाद सफल",
  "createDoc.translateFailed": "अनुवाद विफल",
  "verification.status": "सत्यापन स्थिति",
  "verification.inProgress": "सत्यापन प्रगति पर",
  "verification.getVerified": "सत्यापित हों",
  "verification.cancelRequest": "अनुरोध रद्द करें",
  "verification.submit": "सत्यापन के लिए जमा करें",
  "verification.submitting": "जमा हो रहा है...",
  "verification.uploadDocs": "दस्तावेज़ अपलोड करें",
  "verification.level": "सत्यापन स्तर",
  "verification.selectDocType": "दस्तावेज़ प्रकार चुनें...",
  "contracts.generate": "उत्पन्न करें",
  "contracts.backToTemplates": "टेम्पलेट पर वापस",
  "contracts.required": "आवश्यक",
  "contracts.modify": "संशोधित करें",
  "contracts.finalize": "अंतिम रूप दें",
  "contracts.applyChanges": "परिवर्तन लागू करें",
  "contracts.confirmDelete": "यह ड्राफ्ट हटाएं?",
  "contracts.generating": "दस्तावेज़ तैयार हो रहा है...",
  "templates.deleting": "हटाया जा रहा है...",
  "templates.noDescription": "कोई विवरण नहीं।",
  "templates.use": "उपयोग करें",
  "templates.lib.ndaMutual": "पारस्परिक गोपनीयता समझौता",
  "templates.lib.purchaseAgreement": "खरीद समझौता",
  "templates.lib.serviceAgreement": "सेवा समझौता",
  "templates.lib.priceQuote": "मूल्य उद्धरण",
  "templates.lib.invoice": "चालान",
  "templates.lib.loi": "आशय पत्र",
  "settings.security": "सुरक्षा",
  "security.twoFactor": "दो-कारक प्रमाणीकरण",
  "security.enabled": "सक्षम",
  "security.disabled": "अक्षम",
  "security.enable2FA": "2FA सक्षम करें",
  "security.disable": "अक्षम करें",
  "security.activeSessions": "सक्रिय सत्र",
  "security.logoutAll": "सभी से लॉगआउट",
  "security.loginHistory": "लॉगिन इतिहास",
  "security.verify": "सत्यापित करें",
  "security.cancel": "रद्द करें",
  "security.password": "पासवर्ड",
  "security.done": "पूर्ण",
  "feedback.button": "प्रतिक्रिया",
  "feedback.title": "प्रतिक्रिया भेजें",
  "feedback.typeBug": "बग",
  "feedback.typeFeature": "सुविधा",
  "feedback.typeGeneral": "सामान्य",
  "feedback.submit": "भेजें",
  "feedback.thanks": "धन्यवाद! हम इसे देखेंगे।",
};

export default hi;
